<template>
  <div class="draft-container">
    <!-- 使用独立的工具栏组件 -->
    <DraftToolbar
      :title.sync="title"
      :can-group="canGroup"
      :can-ungroup="canUngroup"
      :can-undo="canUndo"
      :can-redo="canRedo"
      :copy-text="copyText"
      :graph="graph"
      :history="history"
      :draft-id="draftId"
      @group-selected-nodes="groupSelectedNodes"
      @ungroup-selected-nodes="ungroupSelectedNodes"
      @upload-file="uploadFile"
      @handle-file-select="handleFileSelect"
      @to-share="toShare"
      @download-image="downloadImage"
      @add-node="handleAddNode"
      @save-draft="handleSaveDraft"
      @jump-to-bubble="handleJumpToBubble"
      ref="toolbar"
    />
    <div class="draft-con">
      <div id="graph-container"></div>
      
      <!-- 使用独立的右键菜单组件 -->
      <DraftContextMenu
        :visible.sync="menuShow"
        :position="menu"
        :current-node="currentNode"
        :graph="graph"
        @menu-click="handleContextMenuClick"
        @node-edit="handleNodeEdit"
        @open-add-group="handleOpenAddGroup"
        @node-remove="handleNodeRemove"
        @node-remove-color="handleNodeRemoveColor"
      />
      
      <div class="more-tooltip" v-show="tooltipMore" :style="{ left: tooltipObj.x + 'px', top: tooltipObj.y + 'px' }">
        <p>{{ tooltipText }}</p>
      </div>
      
      <!-- 实体悬浮提示框 -->
      <div class="entity-hover-tooltip" v-show="entityHoverTooltip.visible" :style="{ left: entityHoverTooltip.x + 'px', top: entityHoverTooltip.y + 'px' }">
        <pre>{{ entityHoverTooltip.content }}</pre>
      </div>
      
      <!-- 关系悬浮提示框 -->
      <div class="relationship-hover-tooltip" v-show="relationshipHoverTooltip.visible" :style="{ left: relationshipHoverTooltip.x + 'px', top: relationshipHoverTooltip.y + 'px' }">
        <pre>{{ relationshipHoverTooltip.content }}</pre>
      </div>
    </div>
    <Node :drawer="drawer" :currentNode="currentNode" @update:drawer="drawer = $event" @update:node="updateNode"
      @add:node="addChildNode"></Node>
    <Edge :edgeVisible="edgeVisible" :currentEdge="currentEdge" @update:visible="edgeVisible = false"
      @update:edge="updateEdge"></Edge>
    <el-dialog title="分享白板" :visible.sync="shareDialog" width="50%" :before-close="handleShareClose">
      <div class="friend-list">
        <el-checkbox-group v-model="checkList">
          <div class="item-friend" v-for="item in friendList" :key="item.bei_member_id">
            <div class="left">
              <el-checkbox :label="item.bei_member_id"></el-checkbox>
            </div>
            <div class="right">
              <img :src="item.member_avatar" />
              <span class="nick">{{ item.member_name }}</span>
            </div>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shareDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitShare">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="添加组元素" :visible.sync="addGroupVisible" width="50%">
      <div class="add-group-from">
        <div class="item">
          组件名称:
          <el-input v-model="groupObj.name" placeholder="请输入组名称" style="width: 300px" />
        </div>
        <div class="item">
          组件类型:
          <el-select v-model="groupObj.type" placeholder="请选择">
            <el-option label="矩形" :value="1"></el-option>
            <el-option label="圆形" :value="2"></el-option>
            <el-option label="六边形" :value="3"></el-option>
            <el-option label="图片" :value="4"></el-option>
          </el-select>
        </div>
        <div class="item" v-if="groupObj.type === 4">
          上传文件
          <el-input id="updateFile" v-model="groupObj.file" type="file" accept="image/*" style="width: 300px" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addGroupVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGroupNode">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 组合元素对话框 -->
    <el-dialog title="创建组合" :visible.sync="groupComboVisible" width="50%">
      <div class="group-combo-form">
        <div class="item">
          <label>组合名称:</label>
          <el-input 
            v-model="groupComboObj.name" 
            placeholder="请输入组合名称" 
            style="width: 300px; margin-left: 10px;" 
          />
        </div>
        <div class="item">
          <el-checkbox v-model="groupComboObj.showBorder">显示边框</el-checkbox>
        </div>
        <div v-if="groupComboObj.showBorder" class="border-settings">
          <div class="item">
            <label>边框颜色:</label>
            <el-color-picker 
              v-model="groupComboObj.borderColor" 
              style="margin-left: 10px;"
            />
          </div>
          <div class="item">
            <label>边框宽度:</label>
            <el-input-number 
              v-model="groupComboObj.borderWidth" 
              :min="1" 
              :max="10" 
              style="margin-left: 10px; width: 120px;"
            />
          </div>
          <div class="item">
            <label>背景颜色:</label>
            <el-color-picker 
              v-model="groupComboObj.backgroundColor" 
              show-alpha 
              style="margin-left: 10px;"
            />
          </div>
        </div>
        <div class="selected-nodes-info">
          <p>已选择 {{ selectedNodesForCombo.length }} 个节点进行组合</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="groupComboVisible = false">取 消</el-button>
        <el-button type="primary" @click="createGroupCombo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/http/request'
import { Graph } from '@antv/x6'
import { Clipboard } from '@antv/x6-plugin-clipboard'
import { Export } from '@antv/x6-plugin-export'
import { History } from '@antv/x6-plugin-history'
import { Keyboard } from '@antv/x6-plugin-keyboard'
import { Selection } from '@antv/x6-plugin-selection'
import { Snapline } from '@antv/x6-plugin-snapline'
import { Transform } from '@antv/x6-plugin-transform'
import ClipboardJS from 'clipboard'
import { Loading } from 'element-ui'
import DraftToolbar from './DraftToolbar.vue'
import DraftContextMenu from './DraftContextMenu.vue'
import Edge from './edge.vue'
import GraphOnEvent from './event'
import Group from './group'
import Node from './node.vue'
import NodeEvent from './nodeEvent'
import {
childNode,
cirNode,
getChildNodePositions,
getId,
getRectPort,
hexagonNode,
rectNode,
textNode,
typeLine
} from './util'

let isSubmit = false
const sizeLimit = 4 * 1024 * 1024
export default {
  data () {
    return {
      userinfo: JSON.parse(localStorage.getItem('userinfo')),
      checkList: [],
      graph: null,
      history: null,
      canRedo: false,
      canUndo: false,
      drawer: false,
      edgeVisible: false,
      title: '',
      currentNode: null,
      currentEdge: null,
      menuShow: false,
      menu: {
        x: 0,
        y: 0
      },
      isDownload: false,
      exportInstance: null,
      selection: null,
      friendList: [],
      copyText: '',
      select: true,
      shareDialog: false,
      tooltipMore: false,
      tooltipText: 'text', // 用户hover 子节点，内容过多的时候展示tooltip
      tooltipObj: {
        x: 0,
        y: 0
      },
      group: null,
      addGroupVisible: false,
      groupObj: {
        name: '',
        type: 1,
        file: null
      },
      groupComboVisible: false,
      groupComboObj: {
        name: '',
        showBorder: false,
        borderColor: '#409eff',
        borderWidth: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
      },
      selectedNodesForCombo: [], // 存储要组合的节点
      canGroup: false, // 是否可以组合
      canUngroup: false, // 是否可以取消组合
      // 实体分析相关数据
      entityAnalysisData: null,
      selectedEntityId: null,
      visibleRelationships: [],
      selectedRelationship: null,
      entityIdToNodeMap: {},
      entityIndexMap: {}, // 实体ID到索引的映射
      relationshipDetailNodes: [], // 存储关系详情节点
      nodeDetailNodes: [], // 存储节点详情节点
      currentDetailNode: null, // 当前显示详情的节点
      // 悬浮提示框相关数据
      entityHoverTooltip: {
        visible: false,
        content: '',
        x: 0,
        y: 0
      },
      relationshipHoverTooltip: {
        visible: false,
        content: '',
        x: 0,
        y: 0
      },
      // 双击拖拽相关变量
      isPanningEnabled: false, // 拖拽是否已启用
      // 分类分析相关数据
      categoryAnalysisData: null,
      categoryNodes: [], // 存储分类节点
      elementNodes: [] // 存储元素节点
    }
  },
  components: {
    DraftToolbar,
    DraftContextMenu,
    Node,
    Edge
  },
  props: ['draftId'],
  watch: {
    draftId (val) {
      if (!val) {
        this.title = ''
        this.graph?.clearCells()
        // 检查history对象是否存在且有clear方法
        if (this.history && typeof this.history.clear === 'function') {
          this.history.clear()
        }
        return
      }
      // 注意：不在这里清空历史，而是在 getDetail 加载完成后清空
      this.getDetail()
    }
  },
  created() {
    // 检查是否是从实体分析跳转过来的
    if (this.$route.query.type === 'entity-analysis') {
      // 如果有白板ID，说明已经保存过了，不需要再从sessionStorage加载
      if (!this.$route.query.id) {
        this.loadEntityAnalysisResult()
      }
    }
    
    // 检查是否是从分类分析跳转过来的
    if (this.$route.query.type === 'category-analysis') {
      // 如果有白板ID，说明已经保存过了，直接加载白板数据
      if (this.$route.query.id) {
        // 白板数据会在getDetail方法中加载和渲染
      }
    }
  },
  methods: {
    // 处理工具栏添加节点事件
    handleAddNode(node) {
      this.graph.addNode(node)
    },
    
    // 处理工具栏保存事件
    handleSaveDraft(json) {
      if (this.draftId) {
        this.editDraft(json)
      } else {
        this.addDraft(json)
      }
    },
    
    // 处理跳转到气泡图
    handleJumpToBubble() {
      // 检查是否有实体数据
      if (!this.entityAnalysisData || !this.entityAnalysisData.entities || this.entityAnalysisData.entities.length === 0) {
        this.$message.warning('当前白板没有实体关系数据，无法进入气泡图')
        return
      }
      
      const entities = this.entityAnalysisData.entities
      
      // 将实体转换为词条列表格式，设置到store中
      const entryList = entities.map((entity, index) => ({
        id: entity.id || `entity_${index}`,
        name: entity.name,
        type: 'entity'
      }))
      
      // 设置词条列表到store中，这样气泡图页面就能显示左侧的关键词列表
      this.$store.dispatch('processFlow/setEntryList', entryList)
      
      // 如果只有一个实体，直接跳转
      if (entities.length === 1) {
        const searchKeyword = entities[0].name
        this.jumpToBubbleWithKeyword(searchKeyword)
        return
      }
      
      // 如果有多个实体，让用户选择
      const entityOptions = entities.slice(0, 5).map(entity => entity.name).join('、')
      
      this.$confirm(`检测到多个实体，将使用"${entities[0].name}"作为搜索关键词进入气泡图。\n\n可选实体：${entityOptions}`, '进入气泡图', {
        confirmButtonText: '确认进入',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.jumpToBubbleWithKeyword(entities[0].name)
      }).catch(() => {
        // 用户取消，不做任何处理
      })
    },
    
    // 跳转到气泡图的具体实现
    jumpToBubbleWithKeyword(keyword) {
      this.$router.push({
        name: 'bubble',
        query: {
          fromDraft: true,
          source: 'direct', // 标记为直接跳转
          keyword: keyword // 传递搜索关键词
        }
      })
      
      this.$message.success(`正在跳转到气泡图，搜索关键词：${keyword}`)
    },
    
    // 处理右键菜单事件
    handleNodeEdit(node) {
      this.currentNode = node
      this.drawer = true
    },
    
    handleOpenAddGroup(node) {
      this.addGroupVisible = true
    },
    
    handleNodeRemove(node) {
      // 右键菜单组件已经处理了删除逻辑，这里可以添加额外的清理工作
    },
    
    handleNodeRemoveColor(node) {
      // 右键菜单组件已经处理了颜色移除逻辑，这里可以添加额外的处理
    },
    
    // 处理右键菜单点击事件（主要处理组合相关操作）
    handleContextMenuClick({ action, node }) {
      this.currentNode = node
      
      switch (action) {
        case 'edit-group':
          this.editGroupCombo()
          break
        case 'ungroup':
          this.ungroupCurrentNode()
          break
        default:
      }
    },
    addGroup () {
      this.group.addGroup()
    },
    // 组合选中的节点
    groupSelectedNodes () {
      const selectedCells = this.selection.getSelectedCells()
      const selectedNodes = selectedCells.filter(cell => cell.isNode())
      
      // 过滤掉不可见的组合节点，只处理实际的可见节点
      const visibleNodes = selectedNodes.filter(node => !node.getData()?.invisible)
      
      if (visibleNodes.length < 2) {
        this.$message.info('请选择至少两个节点进行组合')
        return
      }

      // 存储要组合的节点
      this.selectedNodesForCombo = visibleNodes
      
      // 重置组合对象为默认值，并默认显示边框
      this.groupComboObj = {
        name: '',
        showBorder: true, // 默认显示边框
        borderColor: '#409eff',
        borderWidth: 2,
        backgroundColor: 'rgba(64, 158, 255, 0.1)'
      }
      
      // 显示组合对话框
      this.groupComboVisible = true
    },
    // 创建或更新组合（从弹窗确认）
    createGroupCombo () {
      if (!this.groupComboObj.name.trim()) {
        this.$message.warning('请输入组合名称')
        return
      }

      const visibleNodes = this.selectedNodesForCombo
      if (visibleNodes.length < 2) {
        this.$message.error('选中的节点数量不足')
        return
      }

      // 检查是否是编辑现有组合
      const isEditing = this.currentNode && this.currentNode.getData()?.isGroup
      
      if (isEditing) {
        // 更新现有组合
        const groupNode = this.currentNode
        
        // 重新计算边界框（节点可能已经移动）
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity
        const nodeIds = []
        
        visibleNodes.forEach(node => {
          const bbox = node.getBBox()
          minX = Math.min(minX, bbox.x)
          minY = Math.min(minY, bbox.y)
          maxX = Math.max(maxX, bbox.x + bbox.width)
          maxY = Math.max(maxY, bbox.y + bbox.height)
          nodeIds.push(node.id)
        })

        const padding = 20
        
        // 更新组合节点的位置和大小
        groupNode.setPosition({ x: minX - padding, y: minY - padding })
        groupNode.setSize({ width: maxX - minX + 2 * padding, height: maxY - minY + 2 * padding })
        
        // 更新标签
        groupNode.setLabel(this.groupComboObj.name)
        
        // 更新样式
        if (this.groupComboObj.showBorder) {
          groupNode.attr('body/fill', this.groupComboObj.backgroundColor)
          groupNode.attr('body/stroke', this.groupComboObj.borderColor)
          groupNode.attr('body/strokeWidth', this.groupComboObj.borderWidth)
          groupNode.attr('body/strokeDasharray', '5 5')
          groupNode.attr('label/fontSize', 14)
          groupNode.attr('label/fill', '#333')
        } else {
          groupNode.attr('body/fill', 'transparent')
          groupNode.attr('body/stroke', 'transparent')
          groupNode.attr('body/strokeWidth', 0)
          groupNode.attr('label/fontSize', 0)
        }
        
        // 更新数据
        groupNode.setData({
          ...groupNode.getData(),
          groupName: this.groupComboObj.name,
          showBorder: this.groupComboObj.showBorder,
          borderColor: this.groupComboObj.borderColor,
          borderWidth: this.groupComboObj.borderWidth,
          backgroundColor: this.groupComboObj.backgroundColor,
          invisible: !this.groupComboObj.showBorder
        })
        
        this.$message.success(`成功更新组合"${this.groupComboObj.name}"`)
      } else {
        // 创建新组合
        // 计算所有选中可见节点的边界框
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity
        const nodeIds = []
        
        visibleNodes.forEach(node => {
          const bbox = node.getBBox()
          minX = Math.min(minX, bbox.x)
          minY = Math.min(minY, bbox.y)
          maxX = Math.max(maxX, bbox.x + bbox.width)
          maxY = Math.max(maxY, bbox.y + bbox.height)
          nodeIds.push(node.id)
        })

        // 创建组节点
        const groupId = getId()
        const padding = 20
        const groupAttrs = {
          body: {},
          label: {
            fontSize: 14,
            fill: '#333',
            refX: 0.5,
            refY: -10, // 标签显示在组合框上方
            textAnchor: 'middle'
          }
        }

        // 根据用户配置设置样式
        if (this.groupComboObj.showBorder) {
          groupAttrs.body.fill = this.groupComboObj.backgroundColor
          groupAttrs.body.stroke = this.groupComboObj.borderColor
          groupAttrs.body.strokeWidth = this.groupComboObj.borderWidth
          groupAttrs.body.strokeDasharray = '5 5' // 虚线边框，区别于普通节点
        } else {
          groupAttrs.body.fill = 'transparent'
          groupAttrs.body.stroke = 'transparent'
          groupAttrs.body.strokeWidth = 0
          groupAttrs.label.fontSize = 0 // 隐藏标签
        }

        const groupNode = this.graph.addNode({
          id: groupId,
          x: minX - padding,
          y: minY - padding,
          width: maxX - minX + 2 * padding,
          height: maxY - minY + 2 * padding,
          zIndex: 1,
          label: this.groupComboObj.name,
          attrs: groupAttrs,
          data: {
            id: groupId,
            isGroup: true,
            groupedNodes: nodeIds,
            groupName: this.groupComboObj.name,
            showBorder: this.groupComboObj.showBorder,
            borderColor: this.groupComboObj.borderColor,
            borderWidth: this.groupComboObj.borderWidth,
            backgroundColor: this.groupComboObj.backgroundColor,
            invisible: !this.groupComboObj.showBorder // 如果不显示边框则不可见
          },
          ports: [] // 不显示端口
        })

        // 初始化组合节点的原始位置
        groupNode.prop('originPosition', groupNode.getPosition())
        
        // 将选中的可见节点标记为组的子节点
        visibleNodes.forEach(node => {
          node.setData({ ...node.getData(), parentGroup: groupId })
        })

        // 清除选择并选中新创建的组
        this.selection.reset()
        this.selection.select(groupNode)
        
        this.$message.success(`成功创建组合"${this.groupComboObj.name}"，包含 ${visibleNodes.length} 个节点`)
      }
      
      // 关闭弹窗
      this.groupComboVisible = false
      this.selectedNodesForCombo = []
      this.currentNode = null
      
      this.updateGroupButtons()
    },
    // 编辑组合
    editGroupCombo () {
      if (!this.currentNode || !this.currentNode.getData()?.isGroup) {
        return
      }

      const groupData = this.currentNode.getData()
      
      // 使用组合的当前配置填充弹窗
      this.groupComboObj = {
        name: groupData.groupName || this.currentNode.getLabel() || '组合',
        showBorder: groupData.showBorder || false,
        borderColor: groupData.borderColor || '#409eff',
        borderWidth: groupData.borderWidth || 2,
        backgroundColor: groupData.backgroundColor || 'rgba(255, 255, 255, 0.1)'
      }
      
      // 获取组合中的节点
      this.selectedNodesForCombo = (groupData.groupedNodes || []).map(nodeId => 
        this.graph.getCellById(nodeId)
      ).filter(node => node)
      
      this.groupComboVisible = true
      this.menuShow = false
    },
    // 取消组合
    ungroupSelectedNodes () {
      const selectedCells = this.selection.getSelectedCells()
      const groupNodes = selectedCells.filter(cell => 
        cell.isNode() && cell.getData()?.isGroup && cell.getData()?.groupedNodes
      )
      
      if (groupNodes.length === 0) {
        this.$message.info('请选择一个组合节点进行取消组合')
        return
      }

      groupNodes.forEach(groupNode => {
        const groupedNodeIds = groupNode.getData().groupedNodes || []
        const childNodes = []
        
        // 获取所有子节点并清除组合标记
        groupedNodeIds.forEach(nodeId => {
          const childNode = this.graph.getCellById(nodeId)
          if (childNode) {
            childNodes.push(childNode)
            // 清除父组信息
            const newData = { ...childNode.getData() }
            delete newData.parentGroup
            childNode.setData(newData)
          }
        })

        // 直接移除组节点（因为没有使用X6的父子关系，所以不会影响子节点）
        this.graph.removeCell(groupNode)
        
        // 选中原来的子节点
        if (childNodes.length > 0) {
          this.selection.reset()
          this.selection.select(childNodes)
        }
        
        // 验证节点是否真的还存在
        const existingNodes = childNodes.filter(node => this.graph.getCellById(node.id))
        this.$message.success(`成功取消组合，释放 ${existingNodes.length}/${childNodes.length} 个节点`)
      })
      
      this.updateGroupButtons()
    },
    // 更新组合按钮状态
    updateGroupButtons () {
      const selectedCells = this.selection.getSelectedCells()
      const selectedNodes = selectedCells.filter(cell => cell.isNode())
      
      // 过滤掉不可见的组合节点
      const visibleNodes = selectedNodes.filter(node => !node.getData()?.invisible)
      
      // 可以组合：选中了至少2个可见节点（排除不可见的组合容器）
      this.canGroup = visibleNodes.length >= 2
      
      // 可以取消组合：选中了至少1个组合节点
      this.canUngroup = selectedNodes.length >= 1 && 
        selectedNodes.some(node => node.getData()?.isGroup && node.getData()?.groupedNodes)
    },
    // 取消当前节点的组合（右键菜单）
    ungroupCurrentNode () {
      if (this.currentNode && this.currentNode.getData()?.isGroup && this.currentNode.getData()?.groupedNodes) {
        this.selection.reset()
        this.selection.select(this.currentNode)
        this.ungroupSelectedNodes()
        this.menuShow = false
      }
    },
    addGroupNode () {
      if (!this.groupObj.name) {
        this.$message.info('请填写组件名称')
      }
      const { x, y } = this.currentNode.getPosition()
      let node = rectNode({
        parentId: this.currentNode.id,
        label: this.groupObj.name,
        x: x + 5,
        y: y + 5,
        width: 80,
        height: 40
      })
      if (this.groupObj.type === 2) {
        node = cirNode({
          label: this.groupObj.name,
          x: x + 5,
          y: y + 5,
          width: 60,
          height: 60
        })
      }
      if (this.groupObj.type === 3) {
        node = hexagonNode({
          label: this.groupObj.name,
          x: x + 5,
          y: y + 5,
          width: 100,
          height: 80
        })
      }
      if (this.groupObj.type === 4) {
        const file = document.querySelector('#updateFile').files[0]
        const imageUrl = URL.createObjectURL(file)
        const image = new Image()
        image.src = imageUrl
        image.onload = () => {
          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')
          canvas.width = image.width
          canvas.height = image.height
          context.drawImage(image, 0, 0)
          const base64Data = canvas.toDataURL('image/webp', 0.6)
          let width = image.width
          let height = image.height
          if (width > 200) {
            width = 200
            height = height / (image.width / 200)
          }
          node = this.graph.addNode({
            id: getId(),
            shape: 'image',
            x: 10,
            y: 10,
            width,
            height,
            imageUrl: base64Data,
            ports: getRectPort(width, height)
          })
        }
      }
      const newNode = this.graph.addNode(node)
      this.currentNode.addChild(newNode)
      this.addGroupVisible = false
      this.groupObj = {
        name: '',
        type: 1,
        file: null
      }
    },
    handleFileSelect () {
      const loading = this.$loading({
        lock: true,
        text: '文件导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (this.draftId) {
        this.save()
      }
      const fileInput = this.$refs.textFile
      const file = fileInput.files[0]

      if (file.size > sizeLimit) {
        fileInput.value = ''
        this.$message.error('文件大小超过限制')
        return
      }

      const formData = new FormData()
      formData.append('file', file)
      formData.append('member_id', this.userinfo.userid)
      formData.append('draft_id', this.draftId)
      // 使用XMLHttpRequest或Fetch API发送数据
      var xhr = new XMLHttpRequest()
      const authorization = localStorage.getItem('authorization')
      xhr.open('POST', '/api/Draft/batchDraftContent', true)
      xhr.setRequestHeader('Authorization', authorization)
      xhr.onload = () => {
        if (xhr.status === 200) {
          const result = JSON.parse(xhr.responseText).result
          const id = result.id.toString()
          if (this.draftId.toString() === id) {
            this.getDetail()
          } else {
            this.$router.push({
              name: 'draft',
              query: {
                id: id
              }
            })
          }
          loading.close()
        } else {
          loading.close()
          this.$message.error('文件上传失败')
        }
        fileInput.value = ''
      }
      xhr.send(formData)
    },
    uploadFile () {
      this.$refs.toolbar.triggerTextUpload()
    },
    search () {
      // 遍历所有节点，根据搜索内容匹配来动态改变节点标签的颜色
      this.graph.getNodes().forEach((node) => {
        const label = node.getLabel()
        if (label) {
          const text = label
          const htmlLabel = document.createElement('div')

          // 根据搜索内容匹配来动态改变文字颜色
          const coloredText = text.replace(
            new RegExp('新', 'g'),
            '<span style="color: #00FF00;">新</span>'
          )
          htmlLabel.innerHTML = coloredText

          label.attr('html', htmlLabel)
        }
      })
    },
    addVerticalLine () {
      this.graph.addEdge({
        source: { x: 40, y: 40 },
        target: { x: 40, y: 180 }
      })
    },
    handleShareClose () {
      this.shareDialog = false
    },
    toShare (command) {
      if (command) {
        if (!this.title) {
          return this.$message.info('文档名称不能为空')
        }
        // 设置分享链接文本
        if (this.userinfo) {
          this.copyText = `你的好友分享了${this.title} 请复制链接在浏览器打开\n https://www.bookor.com.cn/#/editor/draft?id=${this.draftId}&userId=${this.userinfo.userid}`
        } else {
          // 如果没有用户信息，仍然生成分享链接（不带userId）
          this.copyText = `你的好友分享了${this.title} 请复制链接在浏览器打开\n https://www.bookor.com.cn/#/editor/draft?id=${this.draftId}`
        }
        this.$nextTick(() => {
          // copyBtn 位于 DraftToolbar 组件内，需要通过 toolbar ref 访问
          const copyBtn = this.$refs.toolbar?.$refs?.copyBtn
          if (copyBtn) {
            copyBtn.click()
          } else {
            // 如果找不到元素，使用备用复制方案
            this.fallbackCopy()
          }
        })
      } else {
        request('/mobile/member/myFans', {
          key: this.userinfo?.key,
          type: '0'
        })
          .then((result) => {
            const list = result
            this.shareDialog = true
            this.friendList = list
          })
          .catch(() => {
            this.$message.error('获取好友失败')
          })
      }
    },
    fallbackCopy() {
      // 使用现代浏览器的 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.copyText).then(() => {
          this.$message.success('站外分享链接复制成功, 您可以发送给你的好友')
        }).catch(err => {
          console.error('Clipboard API复制失败:', err)
          // 备用方案：显示链接让用户手动复制
          this.$alert(this.copyText, '请手动复制链接', {
            confirmButtonText: '确定',
            type: 'info'
          })
        })
      } else {
        // 备用方案：显示链接让用户手动复制
        this.$alert(this.copyText, '请手动复制链接', {
          confirmButtonText: '确定',
          type: 'info'
        })
      }
    },
    submitShare () {
      if (!this.checkList.length) {
        return this.$message.info('请选择分享人')
      }
      request('/api/Draft/draftShare', {
        draft_id: this.draftId,
        member_ids: this.checkList.join()
      }).then(() => {
        this.$message.success('分享成功')
        this.shareDialog = false
      })
    },
    addChildNode (obj) {
      // 添加子元素
      const { idx, data, total, ids } = obj
      const arr = getChildNodePositions(data, total)
      // 子元素位置重新排列
      if (idx > 0) {
        for (let i = 0; i < idx; i += 1) {
          const currentNode = this.graph.getCellById(ids[i].toString())
          if (currentNode) {
            currentNode.setPosition({ x: arr[i].x, y: arr[i].y })
          }
        }
      }
      const child = childNode(obj, arr[total - 1].x, arr[total - 1].y)
      this.graph.addNode(child)
      // 移除父元素和子元素之间的连接线 - 不再添加 edge
    },
    handleSelect () {
      this.select = !this.select
      this.graph.togglePanning(!this.select)
      this.selection.toggleRubberband(this.select)
    },
    updatePort (node) {
      const { width, height } = node.getBBox()
      const currentNode = this.graph.getCellById(node.id)
      currentNode.setPortProp('port1', 'args', {
        x: 0,
        y: height / 2
      })
      currentNode.setPortProp('port2', 'args', {
        x: width,
        y: height / 2
      })
      currentNode.setPortProp('port3', 'args', {
        x: width / 2,
        y: 0
      })
      currentNode.setPortProp('port4', 'args', {
        x: width / 2,
        y: height
      })
    },
    updateNode (node) {
      try {
        const currentNode = this.graph.getCellById(node.id)
        if (!currentNode) {
          console.error('无法找到要更新的节点:', node.id)
          this.drawer = false
          return
        }
        
        currentNode.setLabel(node.label)
        
        // 检查是否是分类分析的元素节点
        const isElement = currentNode.getData()?.isElement && currentNode.getData()?.elementData
        
        if (currentNode.shape === 'image') {
          currentNode.attr('label/refY', 0.9)
          currentNode.attr('label/refX', 0.5)
          currentNode.attr('label/fill', '#f00')
          currentNode.attr('label/fontSize', 14)
        }
        
        // 根据节点类型设置文字颜色
        if (isElement) {
          // 分类分析元素节点使用 label/fill
          currentNode.attr('label/fill', node.textColor)
        } else {
          // 普通节点使用 text/fill
          currentNode.attr('text/fill', node.textColor)
        }
        
        currentNode.attr('body/fill', node.backgroundColor)
        currentNode.attr('body/stroke', node.textColor)
        currentNode.attr('body/strokeWidth', node.border ? 1 : 0)
        currentNode.setProp('size', { width: node.width, height: node.height })
        this.updatePort(currentNode)
        
        // 更新成功后关闭编辑对话框
        this.drawer = false
        this.$message.success('节点更新成功')
      } catch (error) {
        console.error('更新节点时发生错误:', error)
        this.$message.error('更新节点失败')
        this.drawer = false
      }
    },
    newVertices (target, source) {
      // 获取源节点和目标节点的位置
      const sourcePos = source.position()
      const targetPos = target.position()
      
      // 计算节点中心点（考虑节点大小）
      const sourceSize = source.getSize()
      const targetSize = target.getSize()
      const sourceCenterX = sourcePos.x + sourceSize.width / 2
      const sourceCenterY = sourcePos.y + sourceSize.height / 2
      const targetCenterX = targetPos.x + targetSize.width / 2
      const targetCenterY = targetPos.y + targetSize.height / 2
      
      // 计算中点坐标
      const midX = (sourceCenterX + targetCenterX) / 2
      const midY = (sourceCenterY + targetCenterY) / 2
      
      // 计算连线的方向向量
      const deltaX = targetCenterX - sourceCenterX
      const deltaY = targetCenterY - sourceCenterY
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)
      
      // 如果距离太小，返回中点
      if (distance < 50) {
        return [{ x: midX, y: midY }]
      }
      
      // 计算垂直于连线方向的向量（用于控制曲线凸出方向）
      const perpX = -deltaY / distance // 垂直向量X
      const perpY = deltaX / distance  // 垂直向量Y
      
      // 控制点偏移量（距离的1/4，确保曲线明显但不过度）
      const offset = Math.min(distance * 0.25, 100) // 最大偏移100px
      
      // 根据连线方向决定凸出方向
      let controlX, controlY
      
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        // 水平方向为主：向下凸出
        controlX = midX + perpX * offset
        controlY = midY + Math.abs(perpY * offset) // 总是向下
      } else {
        // 垂直方向为主：向左凸出
        controlX = midX - Math.abs(perpX * offset) // 总是向左
        controlY = midY + perpY * offset
      }
      
      return [{ x: controlX, y: controlY }]
    },
    updateEdge (edge) {
      const currentEdge = this.graph.getCellById(edge.id)
      currentEdge.setLabelAt(0, edge.label)
      currentEdge.attr('line/stroke', edge.color)
      currentEdge.attr('line/vertices', edge.color)
      const point = this.newVertices(
        currentEdge.getTargetNode(),
        currentEdge.getSourceNode()
      )

      if (edge.category === 1) {
        // 曲线
        currentEdge.vertices = point
        currentEdge.setConnector('smooth')
        currentEdge.setRouter(undefined)
      } else if (edge.category === 2) {
        // 折线
        currentEdge.vertices = []
        currentEdge.setRouter({ name: 'orth' })
        currentEdge.setConnector({ name: 'rounded' })
      } else {
        // 直线
        currentEdge.vertices = []
        currentEdge.setConnector(undefined)
        currentEdge.setRouter(undefined)
      }

      if ([2, 4, 6].includes(edge.type)) {
        currentEdge.attr('line/strokeDasharray', '5 3')
      } else {
        currentEdge.attr('line/strokeDasharray', '0')
      }
      const line = typeLine(edge.type)
      currentEdge.attr({
        line: {
          sourceMarker: line.sourceMarker,
          targetMarker: line.targetMarker
        }
      })
      this.edgeVisible = false
    },
    addDraft (json) {
      if (!isSubmit) {
        isSubmit = true
        request('/api/Draft/addDraft', {
          title: this.title,
          content: JSON.stringify(json)
        })
          .then((result) => {
            isSubmit = false
            this.$emit('editDraftId', result)
            this.$message({
              message: '保存成功',
              type: 'success',
              duration: 1000
            })
          })
          .catch(() => {
            this.$message({
              message: '保存失败，系统错误',
              type: 'error',
              duration: 1000
            })
          })
      }
    },
    editDraft (json) {
      request('/api/Draft/editDraft', {
        id: this.draftId,
        title: this.title,
        content: JSON.stringify(json)
      })
        .then((result) => {
          this.$message({
            message: '保存成功',
            type: 'success',
            duration: 1000
          })
        })
        .catch(() => {
          this.$message({
            message: '保存失败，系统错误',
            type: 'error',
            duration: 1000
          })
        })
    },
    downloadImage () {
      this.isDownload = true
      this.exportInstance.exportPNG(this.title || 'download', {
        width: 4500,
        height: 4500,
        backgroundColor: '#fff',
        padding: 1,
        quality: 1
      })
      setTimeout(() => {
        this.isDownload = false
        this.$message.success('下载成功')
      }, 2000)
    },
    getDetail () {
      this.loadingInstance = Loading.service({
        fullscreen: true, // 是否全屏遮罩
        text: '加载中...', // 显示的文本
        background: 'rgba(0, 0, 0, 0.7)' // 遮罩的背景颜色
      })
      request('/api/Draft/draftDetail', {
        id: this.draftId
      })
        .then((result) => {
          this.loadingInstance.close()
          const data = result.content
          this.title = result.title
          
          if (data) {
            try {
              const parsedData = JSON.parse(data)
              
              // 检查是否是分类分析数据
              if (parsedData.type === 'category-analysis' && parsedData.categories) {
                this.categoryAnalysisData = parsedData
                // 等待图表组件准备好后渲染分类
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.renderCategoriesOnBoard()
                    // 渲染完成后清空历史记录
                    this.clearHistoryAfterLoad()
                  }, 500)
                })
              }
              // 检查是否是实体分析数据（包含entities数组）
              else if (parsedData.entities && Array.isArray(parsedData.entities)) {
                this.entityAnalysisData = parsedData
                // 等待图表组件准备好后渲染实体
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.renderEntitiesOnBoard()
                    // 渲染完成后清空历史记录
                    this.clearHistoryAfterLoad()
                  }, 500)
                })
              } else {
                // 普通白板数据，按原来的方式加载
                this.graph.fromJSON(parsedData)
                setTimeout(() => {
                  this.showPorts(false)
                  // 加载完成后清空历史记录
                  this.clearHistoryAfterLoad()
                }, 200)
              }
            } catch (error) {
              this.$message.error('白板数据格式错误')
            }
          } else {
            // 数据为空时也清空历史
            this.clearHistoryAfterLoad()
          }
        })
        .catch(() => {
          this.loadingInstance.close()
        })
    },
    // 在加载完成后清空历史记录
    clearHistoryAfterLoad () {
      this.$nextTick(() => {
        if (this.history) {
          // 尝试不同的清空方法
          if (typeof this.history.clear === 'function') {
            this.history.clear()
          } else if (typeof this.history.clean === 'function') {
            this.history.clean()
          } else if (typeof this.history.reset === 'function') {
            this.history.reset()
          } else if (typeof this.history.undo === 'function' && typeof this.history.redo === 'function') {
            // 通过撤销所有操作来清空历史
            let count = 0
            while (this.history.canUndo() && count < 1000) {
              this.history.undo()
              count++
            }
            // 清空重做栈
            count = 0
            while (this.history.canRedo() && count < 1000) {
              this.history.redo()
              count++
            }
            // 再次撤销以清空
            count = 0
            while (this.history.canUndo() && count < 1000) {
              this.history.undo()
              count++
            }
          }
        }
      })
    },
    showPorts (show, targetNode = null) {
      const container = document.getElementById('graph-container')
      if (targetNode) {
        // 只显示指定节点的端口
        const nodeElement = container.querySelector(`[data-cell-id="${targetNode.id}"]`)
        if (nodeElement) {
          const ports = nodeElement.querySelectorAll('.x6-port-body')
          for (let i = 0, len = ports.length; i < len; i += 1) {
            ports[i].style.visibility = show ? 'visible' : 'hidden'
          }
        }
      } else {
        // 显示/隐藏所有端口（用于初始化等场景）
        const ports = container.querySelectorAll('.x6-port-body')
        for (let i = 0, len = ports.length; i < len; i += 1) {
          ports[i].style.visibility = show ? 'visible' : 'hidden'
        }
      }
    },
    hideSnapline () {
      // 因为辅助线官方有点bug，同时出现2条辅助线的话会无法消失，这里自己写方法解决一下
      setTimeout(() => {
        const dom = document.querySelector(
          '.x6-widget-snapline .x6-widget-snapline-horizontal'
        )
        if (dom) {
          dom.style.display = 'none'
          dom.style.display = 'none'
        }

        setTimeout(() => {
          const dom = document.querySelector(
            '.x6-widget-snapline .x6-widget-snapline-vertical'
          )
          if (dom) {
            dom.style.display = ''
            dom.style.display = ''
          }
        }, 2000)
      }, 2000)
    },
    
    // 加载实体分析结果
    loadEntityAnalysisResult() {
      try {
        const analysisResult = sessionStorage.getItem('entityAnalysisResult')
        if (analysisResult) {
          this.entityAnalysisData = JSON.parse(analysisResult)
          
          // 清除sessionStorage中的数据
          sessionStorage.removeItem('entityAnalysisResult')
          
          // 设置标题
          this.title = '实体关系分析'
          
          // 等待图表组件准备好后渲染实体
          this.$nextTick(() => {
            setTimeout(() => {
              this.renderEntitiesOnBoard()
            }, 500)
          })
        }
      } catch (error) {
        this.$message.error('加载实体分析结果失败')
      }
    },
    
    // 在白板上渲染分类和元素
    renderCategoriesOnBoard() {
      
      if (!this.categoryAnalysisData || !this.graph) {
        return
      }
      
      const categories = this.categoryAnalysisData.categories || []
      
      // 清空现有内容
      this.graph.clearCells()
      this.categoryNodes = []
      this.elementNodes = []
      
      // 画布参数
      const canvasWidth = 1200
      const canvasHeight = 800
      const legendWidth = 200
      const legendX = 50
      const legendY = 50
      
      // 渲染右上角的说明部分
      this.renderCategoryLegend(categories, legendX, legendY, legendWidth)
      
      // 渲染左侧的分类和元素
      this.renderCategoryContent(categories, legendX + legendWidth + 100, legendY)
      
      this.$message.success(`成功渲染 ${categories.length} 个分类`)
    },
    
    // 渲染分类说明（右上角的矩形框）
    renderCategoryLegend(categories, startX, startY, width) {
      const itemHeight = 40
      const spacing = 10
      
      categories.forEach((category, index) => {
        const y = startY + index * (itemHeight + spacing)
        
        // 创建说明矩形框
        const legendNode = this.graph.addNode({
          id: `legend_${category.id}`,
          x: startX,
          y: y,
          width: width,
          height: itemHeight,
          label: category.title,
          attrs: {
            body: {
              fill: category.color,
              stroke: category.color,
              strokeWidth: 2,
              rx: 8,
              ry: 8
            },
            label: {
              fontSize: 14,
              fill: '#ffffff',
              fontWeight: 'bold',
              textAnchor: 'middle',
              textVerticalAnchor: 'middle'
            }
          },
          data: {
            isLegend: true,
            categoryId: category.id,
            categoryIndex: index
          }
        })
        
        this.categoryNodes.push(legendNode)
      })
    },
    
    // 渲染分类内容（横向排布，每行最多3个分类）
    renderCategoryContent(categories, startX, startY) {
      const categoriesPerRow = 3     // 每行最多3个分类
      const categoryWidth = 350      // 每个分类容器的宽度
      const categorySpacing = 60     // 分类之间的水平间距
      const rowSpacing = 80          // 行与行之间的垂直间距
      const elementSpacing = 10      // 元素之间的间距
      const elementWidth = 100       // 元素矩形宽度
      const elementHeight = 35       // 元素矩形高度
      const padding = 20             // 分类区域的内边距
      
      categories.forEach((category, categoryIndex) => {
        const elements = category.elements || []
        
        // 计算当前分类在第几行第几列
        const row = Math.floor(categoryIndex / categoriesPerRow)
        const col = categoryIndex % categoriesPerRow
        
        // 计算分类容器的位置
        const categoryX = startX + col * (categoryWidth + categorySpacing)
        const categoryY = startY + row * (250 + rowSpacing) // 250是大致的分类容器高度
        
        // 渲染分类中的元素（保持原有的横向布局）
        elements.forEach((element, elementIndex) => {
          const elementsPerRow = 3 // 每行3个元素
          const elementRow = Math.floor(elementIndex / elementsPerRow)
          const elementCol = elementIndex % elementsPerRow
          
          // 保持原有的元素位置计算方式
          const elementX = categoryX + padding + elementCol * (elementWidth + elementSpacing)
          const elementY = categoryY + padding + elementRow * (elementHeight + elementSpacing)
          
          // 创建独立的元素矩形
          const elementNode = this.graph.addNode({
            id: `element_${element.id}`,
            x: elementX,
            y: elementY,
            width: elementWidth,
            height: elementHeight,
            label: element.text,
            zIndex: 10,
            movable: true, // 明确设置为可移动
            attrs: {
              body: {
                fill: category.color,
                stroke: category.color,
                strokeWidth: 2,
                rx: 6,
                ry: 6,
                cursor: 'move' // 允许拖拽
              },
              label: {
                fontSize: 12,
                fill: '#ffffff',
                fontWeight: 'normal',
                textAnchor: 'middle',
                textVerticalAnchor: 'middle',
                textWrap: {
                  width: elementWidth - 10,
                  height: elementHeight - 5,
                  ellipsis: true
                }
              }
            },
            // 添加连接端口配置，与正常矩形节点一样
            ports: {
              groups: {
                group1: {
                  attrs: {
                    circle: {
                      r: 6,
                      magnet: true,
                      stroke: '#31d0c6',
                      fill: '#fff',
                      strokeWidth: 2,
                      visibility: 'hidden' // 默认隐藏连接桩
                    }
                  },
                  position: {
                    name: 'absolute'
                  }
                }
              },
              items: [
                {
                  id: 'port1',
                  group: 'group1',
                  args: {
                    x: 0,
                    y: elementHeight / 2
                  }
                },
                {
                  id: 'port2',
                  group: 'group1',
                  args: {
                    x: elementWidth,
                    y: elementHeight / 2
                  }
                },
                {
                  id: 'port3',
                  group: 'group1',
                  args: {
                    x: elementWidth / 2,
                    y: 0
                  }
                },
                {
                  id: 'port4',
                  group: 'group1',
                  args: {
                    x: elementWidth / 2,
                    y: elementHeight
                  }
                }
              ]
            },
            data: {
              isElement: true,
              elementId: element.id,
              elementData: element,
              categoryId: category.id,
              categoryColor: category.color,
              hasDescription: !!element.description,
              selectable: true, // 允许选择
              draggable: true   // 允许拖拽
            }
          })
          
          // 设置DOM属性以便CSS选择器识别
          elementNode.attr('data-is-element', 'true')
          
          this.elementNodes.push(elementNode)
        })
      })
    },
    renderEntitiesOnBoard() {
      
      if (!this.entityAnalysisData || !this.graph) {
        return
      }
      
      const entities = this.entityAnalysisData.entities || []
      
      // 保存词条列表到store
      const entryList = entities.map(entity => ({
        id: entity.id,
        name: entity.name || entity.id,
        type: entity.type || '未知'
      }))
      this.$store.dispatch('processFlow/setEntryList', entryList)
      
      // 清空现有内容
      this.graph.clearCells()
      
      // 椭圆布局算法 - 根据实体数量自动调整
      const centerX = 400 // 椭圆中心X坐标
      const centerY = 300 // 椭圆中心Y坐标
      
      // 根据实体数量动态调整椭圆大小
      const baseRadiusX = Math.max(200, entities.length * 15) // 最小200，每个实体增加15
      const baseRadiusY = Math.max(100, entities.length * 8)  // 最小100，每个实体增加8
      const radiusX = Math.min(baseRadiusX, 400) // 最大不超过400
      const radiusY = Math.min(baseRadiusY, 200)  // 最大不超过200
      
      // 渲染每个实体为矩形节点
      entities.forEach((entity, index) => {
        // 计算椭圆上的角度
        const angle = (2 * Math.PI * index) / entities.length
        
        // 计算椭圆上的位置
        const x = centerX + radiusX * Math.cos(angle)
        const y = centerY + radiusY * Math.sin(angle)
        
        // 根据实体名称长度动态调整框大小
        const entityName = entity.name || entity.id
        const nameLength = entityName.length
        const width = Math.max(60, Math.min(nameLength * 12, 100)) // 最小60，最大100
        const height = 35 // 固定高度，更紧凑
        
        
        const node = rectNode({
          label: entityName,
          x: x - width/2, // 居中对齐
          y: y - height/2, // 居中对齐
          width: width,
          height: height
        })
        
        
        // 添加实体数据到节点
        node.data = {
          ...node.data,
          entityId: entity.id,
          entityData: entity,
          entityIndex: index,  // 保存实体索引
          isEntity: true
        }
        
        this.graph.addNode(node)
      })
      
      // 保存实体映射供后续使用
      this.entityIdToNodeMap = {}
      this.entityIndexMap = {}  // 新增：直接保存实体ID到索引的映射
      entities.forEach((entity, index) => {
        const node = this.graph.getNodes().find(n => 
          n.getData()?.entityId === entity.id
        )
        if (node) {
          this.entityIdToNodeMap[entity.id] = node
          this.entityIndexMap[entity.id] = index  // 直接保存索引映射
        } else {
        }
      })
      
      this.$message.success(`成功渲染 ${entities.length} 个实体`)
    },
    
    // 显示实体相关的关系线条
    showEntityRelationships(entityId) {
      if (!this.entityAnalysisData) {
        return
      }
      
      // 清除之前的关系线条
      this.clearRelationshipEdges()
      
      // 移动被点击的实体到椭圆中心，重新排列其他实体
      this.repositionEntitiesWithCenter(entityId)
      
      // 更新实体颜色状态：只有被激活的实体有颜色，其余为灰色
      this.updateEntityColors(entityId)
      
      const relationships = this.entityAnalysisData.relationships || []
      const relatedRelationships = relationships.filter(rel => 
        rel.source === entityId || rel.target === entityId
      )
      
      
      // 绘制关系线条 - 修改为曲线
      relatedRelationships.forEach(relationship => {
        const sourceNode = this.entityIdToNodeMap[relationship.source]
        const targetNode = this.entityIdToNodeMap[relationship.target]
        
        if (sourceNode && targetNode) {
          // 确定线条样式
          const isDirect = relationship.type === 'direct'
          const strokeDasharray = isDirect ? '0' : '5 3'
          
          const edge = this.graph.addEdge({
            id: `rel_${relationship.id}`,
            source: { cell: sourceNode.id },
            target: { cell: targetNode.id },
            label: relationship.keywords?.join(', ') || '',
            attrs: {
              line: {
                stroke: '#409eff',
                strokeWidth: 2,
                strokeDasharray: strokeDasharray,
                targetMarker: {
                  name: 'classic',
                  width: 10,
                  height: 10
                }
              }
            },
            data: {
              relationshipId: relationship.id,
              relationshipData: relationship,
              isRelationship: true
            },
            connector: 'smooth', // 使用曲线连接器
            zIndex: 100 // 提高层级，确保线条不被框遮挡
          })
          
          this.visibleRelationships.push(edge)
        }
      })
      
      this.selectedEntityId = entityId
      
      if (relatedRelationships.length > 0) {
        this.$message.info(`显示了 ${relatedRelationships.length} 条关系`)
      } else {
        this.$message.info('该实体没有相关关系')
      }
    },
    
    // 重新排列实体，将指定实体移动到椭圆中心
    repositionEntitiesWithCenter(centerEntityId) {
      if (!this.entityAnalysisData || !this.graph) {
        return
      }
      
      const entities = this.entityAnalysisData.entities || []
      const centerX = 400 // 椭圆中心X坐标
      const centerY = 300 // 椭圆中心Y坐标
      
      // 找到中心实体
      const centerEntity = entities.find(e => e.id === centerEntityId)
      if (!centerEntity) {
        return
      }
      
      // 获取除了中心实体外的其他实体
      const otherEntities = entities.filter(e => e.id !== centerEntityId)
      
      // 移动中心实体到椭圆中心
      const centerNode = this.entityIdToNodeMap[centerEntityId]
      if (centerNode) {
        const centerNodeSize = centerNode.getSize()
        centerNode.setPosition({
          x: centerX - centerNodeSize.width / 2,
          y: centerY - centerNodeSize.height / 2
        })
      }
      
      // 保持椭圆大小不变（与初始渲染时相同）
      const baseRadiusX = Math.max(200, entities.length * 15) // 使用全部实体数量，与初始相同
      const baseRadiusY = Math.max(100, entities.length * 8)  // 使用全部实体数量，与初始相同
      const radiusX = Math.min(baseRadiusX, 400) // 最大不超过400，与初始相同
      const radiusY = Math.min(baseRadiusY, 200)  // 最大不超过200，与初始相同
      
      // 重新排列其他实体在椭圆上
      otherEntities.forEach((entity, index) => {
        const angle = (2 * Math.PI * index) / otherEntities.length
        const x = centerX + radiusX * Math.cos(angle)
        const y = centerY + radiusY * Math.sin(angle)
        
        const node = this.entityIdToNodeMap[entity.id]
        if (node) {
          const nodeSize = node.getSize()
          node.setPosition({
            x: x - nodeSize.width / 2,
            y: y - nodeSize.height / 2
          })
        }
      })
      
    },
    
    // 更新实体颜色状态
    updateEntityColors(activeEntityId) {
      if (!this.entityAnalysisData || !this.graph) {
        return
      }
      
      const entities = this.entityAnalysisData.entities || []
      
      entities.forEach(entity => {
        const node = this.entityIdToNodeMap[entity.id]
        if (node) {
          if (entity.id === activeEntityId) {
            // 被激活的实体：橙色背景 + 橙色边框 + 黑色文字
            node.attr('body/fill', '#D97070')
            node.attr('body/stroke', '#D97070')
            node.attr('body/strokeWidth', 2)
            node.attr('label/fill', '#000000')
          } else {
            // 其他实体：灰色背景 + 浅灰色边框 + 灰色文字
            node.attr('body/fill', '#f5f5f5')
            node.attr('body/stroke', '#cccccc')
            node.attr('body/strokeWidth', 1)
            node.attr('label/fill', '#999999')
          }
        }
      })
    },
    
    // 重置所有实体颜色为默认状态
    resetEntityColors() {
      if (!this.entityAnalysisData || !this.graph) {
        return
      }
      
      const entities = this.entityAnalysisData.entities || []
      
      entities.forEach(entity => {
        const node = this.entityIdToNodeMap[entity.id]
        if (node) {
          // 恢复默认颜色
          node.attr('body/fill', '#ffffff')
          node.attr('body/stroke', '#409eff')
          node.attr('body/strokeWidth', 2)
          node.attr('label/fill', '#333333')
        }
      })
    },
    
    // 清除关系线条
    clearRelationshipEdges() {
      this.visibleRelationships.forEach(edge => {
        if (this.graph.getCellById(edge.id)) {
          this.graph.removeCell(edge)
        }
      })
      this.visibleRelationships = []
      this.selectedEntityId = null
      
      // 重置所有实体颜色
      this.resetEntityColors()
      
      // 同时清除关系详情
      this.clearRelationshipDetails()
    },
    
    // 高亮关系线条连接的两个节点
    highlightRelationshipNodes(edge) {
      if (!this.entityAnalysisData || !this.graph) {
        return
      }
      
      const relationshipData = edge.getData()?.relationshipData
      if (!relationshipData) {
        return
      }
      
      // 先重置所有节点颜色为灰色状态
      const entities = this.entityAnalysisData.entities || []
      entities.forEach(entity => {
        const node = this.entityIdToNodeMap[entity.id]
        if (node) {
          // 设置为灰色状态
          node.attr('body/fill', '#f5f5f5')
          node.attr('body/stroke', '#cccccc')
          node.attr('body/strokeWidth', 1)
          node.attr('label/fill', '#999999')
        }
      })
      
      // 高亮目标节点，源节点保持不变
      const sourceNode = this.entityIdToNodeMap[relationshipData.source]
      const targetNode = this.entityIdToNodeMap[relationshipData.target]
      
      // 源节点保持当前激活状态的颜色（红色）
      if (sourceNode) {
        sourceNode.attr('body/fill', '#D97070')
        sourceNode.attr('body/stroke', '#D97070')
        sourceNode.attr('body/strokeWidth', 2)
        sourceNode.attr('label/fill', '#000000')
      }
      
      if (targetNode) {
        // 目标节点高亮为绿色
        targetNode.attr('body/fill', '#E8F5E8')
        targetNode.attr('body/stroke', '#4CAF50')
        targetNode.attr('body/strokeWidth', 3)
        targetNode.attr('label/fill', '#000000')
      }
      
      // 不改变连接线样式，保持原样
      // 不显示提示信息
    },
    
    // 重置关系线条和节点的高亮状态
    resetRelationshipHighlight() {
      if (!this.entityAnalysisData || !this.graph) {
        return
      }
      
      // 线条样式不需要重置，因为没有改变过
      
      // 如果有选中的实体，恢复到选中状态的颜色
      if (this.selectedEntityId) {
        this.updateEntityColors(this.selectedEntityId)
      } else {
        // 否则恢复到默认状态
        this.resetEntityColors()
      }
    },
    
    // 显示关系详细信息
    showRelationshipDetails(relationshipData) {
      
      // 清除之前的关系详情节点
      this.clearRelationshipDetails()
      
      // 获取源实体和目标实体信息
      const sourceEntity = this.entityAnalysisData.entities.find(e => e.id === relationshipData.source)
      const targetEntity = this.entityAnalysisData.entities.find(e => e.id === relationshipData.target)
      
      if (!sourceEntity || !targetEntity) {
        return
      }
      
      // 在画布右下角区域显示关系详情
      const containerEl = document.getElementById('graph-container')
      const canvasWidth = containerEl ? containerEl.clientWidth : (this.graph.options.width || 800)
      const canvasHeight = containerEl ? containerEl.clientHeight : (this.graph.options.height || 600)
      const spacing = 160
      const nodeHeight = 35
      const nodeWidth = 100
      
      // 获取关键词数量
      const keywords = relationshipData.keywords || ['关系']
      
      // 计算右下角起始位置 - 总共需要：源实体 + 关键词 + 目标实体
      const totalNodes = 2 + keywords.length  // 源 + 关键词 + 目标
      const totalWidth = spacing * (totalNodes - 1) + nodeWidth
      const startX = canvasWidth - totalWidth - 50  // 右下角，留50px边距
      const startY = canvasHeight - 150  // 距离底部150px
      
      // 1. 创建源实体节点
      const sourceNode = this.graph.addNode({
        id: `detail_source_${relationshipData.id}`,
        x: startX,
        y: startY,
        width: nodeWidth,
        height: nodeHeight,
        label: sourceEntity.name || sourceEntity.id,
        attrs: {
          body: {
            fill: '#e1f5fe',
            stroke: '#01579b',
            strokeWidth: 2,
            cursor: 'pointer'
          },
          label: {
            fontSize: 12,
            fill: '#01579b'
          }
        },
        ports: {
          groups: {
            'detail-port': {
              position: 'absolute',
              attrs: {
                circle: {
                  r: 0, // 隐藏端口圆圈
                  magnet: true,
                  stroke: 'transparent',
                  strokeWidth: 0,
                  fill: 'transparent'
                }
              }
            }
          },
          items: [
            { id: 'left', group: 'detail-port', args: { x: 0, y: nodeHeight / 2 } },
            { id: 'right', group: 'detail-port', args: { x: nodeWidth, y: nodeHeight / 2 } },
            { id: 'top', group: 'detail-port', args: { x: nodeWidth / 2, y: 0 } },
            { id: 'bottom', group: 'detail-port', args: { x: nodeWidth / 2, y: nodeHeight } }
          ]
        },
        data: {
          isRelationshipDetail: true,
          detailType: 'source'
        }
      })
      
      // 2. 创建关系关键词节点
      const keywordNodes = []
      
      keywords.forEach((keyword, index) => {
        const keywordNode = this.graph.addNode({
          id: `detail_keyword_${relationshipData.id}_${index}`,
          x: startX + spacing * (index + 1),
          y: startY,
          width: 70,
          height: 25,
          label: keyword,
          attrs: {
            body: {
              fill: '#fff3e0',
              stroke: '#f57c00',
              strokeWidth: 1,
              rx: 15, // 圆角
              ry: 15,
              cursor: 'pointer'
            },
            label: {
              fontSize: 10,
              fill: '#e65100'
            }
          },
          ports: {
            groups: {
              'detail-port': {
                position: 'absolute',
                attrs: {
                  circle: {
                    r: 0, // 隐藏端口圆圈
                    magnet: true,
                    stroke: 'transparent',
                    strokeWidth: 0,
                    fill: 'transparent'
                  }
                }
              }
            },
            items: [
              { id: 'left', group: 'detail-port', args: { x: 0, y: 25 / 2 } },
              { id: 'right', group: 'detail-port', args: { x: 70, y: 25 / 2 } },
              { id: 'top', group: 'detail-port', args: { x: 70 / 2, y: 0 } },
              { id: 'bottom', group: 'detail-port', args: { x: 70 / 2, y: 25 } }
            ]
          },
          data: {
            isRelationshipDetail: true,
            detailType: 'keyword'
          }
        })
        keywordNodes.push(keywordNode)
      })
      
      // 3. 创建目标实体节点
      const targetNode = this.graph.addNode({
        id: `detail_target_${relationshipData.id}`,
        x: startX + spacing * (keywords.length + 1),
        y: startY,
        width: nodeWidth,
        height: nodeHeight,
        label: targetEntity.name || targetEntity.id,
        attrs: {
          body: {
            fill: '#f3e5f5',
            stroke: '#4a148c',
            strokeWidth: 2,
            cursor: 'pointer'
          },
          label: {
            fontSize: 12,
            fill: '#4a148c'
          }
        },
        ports: {
          groups: {
            'detail-port': {
              position: 'absolute',
              attrs: {
                circle: {
                  r: 0, // 隐藏端口圆圈
                  magnet: true,
                  stroke: 'transparent',
                  strokeWidth: 0,
                  fill: 'transparent'
                }
              }
            }
          },
          items: [
            { id: 'left', group: 'detail-port', args: { x: 0, y: nodeHeight / 2 } },
            { id: 'right', group: 'detail-port', args: { x: nodeWidth, y: nodeHeight / 2 } },
            { id: 'top', group: 'detail-port', args: { x: nodeWidth / 2, y: 0 } },
            { id: 'bottom', group: 'detail-port', args: { x: nodeWidth / 2, y: nodeHeight } }
          ]
        },
        data: {
          isRelationshipDetail: true,
          detailType: 'target'
        }
      })
      
      // 4. 连接所有节点 - 明确指定连接点位置
      const allNodes = [sourceNode, ...keywordNodes, targetNode]
      for (let i = 0; i < allNodes.length - 1; i++) {
        const sourceCell = allNodes[i]
        const targetCell = allNodes[i + 1]
        
        // 明确指定连接点：源节点右边，目标节点左边
        const edge = this.graph.addEdge({
          id: `detail_edge_${relationshipData.id}_${i}`,
          source: { 
            cell: sourceCell.id,
            port: 'right' // 明确指定从右边连接点出去
          },
          target: { 
            cell: targetCell.id,
            port: 'left' // 明确指定从左边连接点进来
          },
          attrs: {
            line: {
              stroke: '#666',
              strokeWidth: 2,
              strokeDasharray: relationshipData.type === 'direct' ? '0' : '5 3',
              targetMarker: {
                name: 'classic',
                width: 8,
                height: 8
              }
            }
          },
          connector: 'smooth', // 使用曲线连接器
          data: {
            isRelationshipDetail: true
          }
        })
        this.relationshipDetailNodes.push(edge)
      }
      
      // 5. 添加描述信息节点
      if (relationshipData.description) {
        const descNode = this.graph.addNode({
          id: `detail_desc_${relationshipData.id}`,
          x: startX,
          y: startY + 50,  // 调整描述框位置
          width: totalWidth,  // 使用计算好的总宽度
          height: 45,  // 稍微减小高度
          label: relationshipData.description,
          attrs: {
            body: {
              fill: '#f5f5f5',
              stroke: '#ccc',
              strokeWidth: 1,
              cursor: 'pointer'
            },
            label: {
              fontSize: 10,
              fill: '#333',
              textWrap: {
                width: totalWidth - 20,  // 使用计算好的总宽度
                height: 35,
                ellipsis: true
              }
            }
          },
          data: {
            isRelationshipDetail: true,
            detailType: 'description'
          }
        })
        this.relationshipDetailNodes.push(descNode)
      }
      
      // 6. 添加半透明背景框
      const backgroundNode = this.graph.addNode({
        id: `detail_background_${relationshipData.id}`,
        x: startX - 15,
        y: startY - 15,
        width: totalWidth + 30,
        height: relationshipData.description ? 115 : 65,  // 根据是否有描述调整高度
        attrs: {
          body: {
            fill: 'rgba(255, 255, 255, 0.9)',
            stroke: '#ddd',
            strokeWidth: 1,
            rx: 8,
            ry: 8
          }
        },
        data: {
          isRelationshipDetail: true,
          detailType: 'background'
        },
        zIndex: -1  // 置于底层
      })
      
      // 存储所有详情节点
      this.relationshipDetailNodes.push(backgroundNode, sourceNode, ...keywordNodes, targetNode)
      this.selectedRelationship = relationshipData
      
    },
    
    // 清除关系详情节点
    clearRelationshipDetails() {
      this.relationshipDetailNodes.forEach(node => {
        if (this.graph.getCellById(node.id)) {
          this.graph.removeCell(node)
        }
      })
      this.relationshipDetailNodes = []
      this.selectedRelationship = null
      this.clearNodeDetails()
    },
    
    // 清除节点详情
    clearNodeDetails() {
      this.nodeDetailNodes.forEach(node => {
        if (this.graph.getCellById(node.id)) {
          this.graph.removeCell(node)
        }
      })
      this.nodeDetailNodes = []
      this.currentDetailNode = null
    },
    
    // 处理详情节点点击
    handleDetailNodeClick(node) {
      // 清除之前的详情显示
      this.clearNodeDetails()
      
      const detailType = node.getData()?.detailType
      
      if (detailType === 'source' || detailType === 'target') {
        // 点击源实体或目标实体节点
        this.showEntityDetailOnCanvas(node, detailType)
      } else if (detailType === 'keyword') {
        // 点击关键词节点
        this.showKeywordDetailOnCanvas(node)
      } else if (detailType === 'description') {
        // 点击描述节点
        this.showDescriptionDetailOnCanvas(node)
      }
      
      this.currentDetailNode = node
    },
    
    // 处理详情节点悬浮进入
    handleDetailNodeHover(node) {
      // 清除之前的详情显示
      this.clearNodeDetails()
      
      const detailType = node.getData()?.detailType
      
      if (detailType === 'source' || detailType === 'target') {
        // 悬浮源实体或目标实体节点
        this.showEntityDetailOnCanvas(node, detailType)
      } else if (detailType === 'keyword') {
        // 悬浮关键词节点
        this.showKeywordDetailOnCanvas(node)
      } else if (detailType === 'description') {
        // 悬浮描述节点
        this.showDescriptionDetailOnCanvas(node)
      }
      
      this.currentDetailNode = node
    },
    
    // 处理详情节点悬浮离开
    handleDetailNodeLeave(node) {
      // 延迟清除详情显示，给用户时间移动鼠标到详情框上
      setTimeout(() => {
        // 检查鼠标是否在详情框上，如果不在则清除
        if (this.currentDetailNode === node) {
          this.clearNodeDetails()
        }
      }, 200) // 200ms延迟
    },
    
    // 处理详情框悬浮离开
    handleDetailBoxLeave(node) {
      // 延迟清除详情显示，给用户时间移动鼠标
      setTimeout(() => {
        // 清除详情显示
        this.clearNodeDetails()
      }, 300) // 300ms延迟，给用户更多时间
    },
    
    // 在画布上显示实体详细信息
    showEntityDetailOnCanvas(node, detailType) {
      const relationshipData = this.selectedRelationship
      if (!relationshipData) return
      
      // 确定是源实体还是目标实体
      const entityId = detailType === 'source' ? relationshipData.source : relationshipData.target
      const entity = this.entityAnalysisData.entities.find(e => e.id === entityId)
      
      if (!entity) {
        return
      }
      
      // 找到与该实体相关的所有关系
      const relatedRelationships = this.entityAnalysisData.relationships.filter(rel => 
        rel.source === entityId || rel.target === entityId
      )
      
      // 找到与该实体相关的所有事件
      const relatedEvents = this.entityAnalysisData.events.filter(event => 
        event.participants?.includes(entityId)
      )
      
      // 获取被点击节点的位置
      const clickedNodePos = node.getPosition()
      const clickedNodeSize = node.getSize()
      
      // 构建详情文本
      let detailText = `实体：${entity.name}`
      if (entity.attribute) {
        detailText += `\n属性：${entity.attribute}`
      }
      if (entity.event) {
        detailText += `\n事件：${entity.event}`
      }
      if (relatedRelationships.length > 0) {
        detailText += `\n相关关系：`
        relatedRelationships.slice(0, 3).forEach((rel, index) => {
          const otherEntityId = rel.source === entityId ? rel.target : rel.source
          const otherEntity = this.entityAnalysisData.entities.find(e => e.id === otherEntityId)
          const otherEntityName = otherEntity ? otherEntity.name : otherEntityId
          const keywords = rel.keywords ? rel.keywords.join(', ') : '无关键词'
          detailText += `\n  ${index + 1}. 与"${otherEntityName}": ${keywords}`
        })
      }
      if (relatedEvents.length > 0) {
        detailText += `\n参与事件：`
        relatedEvents.slice(0, 2).forEach((event, index) => {
          detailText += `\n  ${index + 1}. ${event.description}`
        })
      }
      
      // 计算详情显示位置（距离节点120像素远，避免遮挡）
      const detailWidth = 320
      const lineHeight = 18
      const textLines = detailText.split('\n')
      const detailHeight = textLines.length * lineHeight + 30
      
      // 获取画布实际尺寸 - 使用正确的容器
      const draftContainer = document.querySelector('.draft-container')
      const canvasWidth = draftContainer ? draftContainer.clientWidth : 1200
      const canvasHeight = window.innerHeight * 0.9
      
      // 根据节点索引决定详情框位置：第一个(索引0)在左边，第四个(索引3)在右边
      // 首先尝试从关系详情节点中获取对应的实体节点索引
      let entityIndex = -1
      
      // 如果这是一个关系详情节点，需要找到对应的实体节点
      if (node.getData()?.detailType === 'source' || node.getData()?.detailType === 'target') {
        const entityId = detailType === 'source' ? this.selectedRelationship.source : this.selectedRelationship.target
        
        // 直接从索引映射中获取
        entityIndex = this.entityIndexMap[entityId] ?? -1
        
        // 如果索引映射失败，尝试从节点数据获取
        if (entityIndex === -1) {
          const entityNode = this.entityIdToNodeMap[entityId]
          if (entityNode) {
            entityIndex = entityNode.getData()?.entityIndex ?? -1
          } else {
          }
        }
      } else if (node.getData()?.entityIndex !== undefined) {
        // 如果是直接点击的实体节点
        entityIndex = node.getData().entityIndex
      }
      
      
      let detailStartX, detailStartY
      
      // 检查是否是关系详情节点（通过节点ID判断）
      const isRelationshipDetailNode = node.id && node.id.includes('detail_')
      
      if (isRelationshipDetailNode) {
        // 如果是关系详情节点，显示在上方
        detailStartX = clickedNodePos.x - (detailWidth - clickedNodeSize.width) / 2 // 水平居中对齐
        detailStartY = clickedNodePos.y - detailHeight - 80 // 显示在节点上方，留80px间距
        
        // 确保不超出左右边界
        if (detailStartX < 20) {
          detailStartX = 20
        }
        if (detailStartX + detailWidth > canvasWidth - 20) {
          detailStartX = canvasWidth - detailWidth - 20
        }
        
        // 确保不超出上边界，如果超出则显示在下方
        if (detailStartY < 20) {
          detailStartY = clickedNodePos.y + clickedNodeSize.height + 80
        }
        
      } else {
        // 原有的实体节点位置逻辑
        detailStartY = clickedNodePos.y
        
        // 根据索引决定位置：索引0(第一个)在左边，索引3(第四个)在右边，其他按边界检测
        if (entityIndex === 0) {
          // 第一个节点强制在左边
          detailStartX = clickedNodePos.x - detailWidth - 120
        } else if (entityIndex === 3) {
          // 第四个节点强制在右边
          detailStartX = clickedNodePos.x + clickedNodeSize.width + 120
        } else {
          // 其他节点按原有逻辑：优先右侧，超出边界则左侧
          detailStartX = clickedNodePos.x + clickedNodeSize.width + 120
          if (detailStartX + detailWidth > canvasWidth - 50) {
            detailStartX = clickedNodePos.x - detailWidth - 120
          }
        }
        
        // 确保不超出左边界
        if (detailStartX < 20) {
          detailStartX = 20
        }
        
        // 确保不超出上下边界
        if (detailStartY < 20) {
          detailStartY = 20
        }
        if (detailStartY + detailHeight > canvasHeight - 20) {
          detailStartY = canvasHeight - detailHeight - 20
        }
      }
      
      // 创建单个详情文本节点
      const detailNode = this.graph.addNode({
        id: `entity_detail_${entity.id}_${Date.now()}`,
        x: detailStartX,
        y: detailStartY,
        width: detailWidth,
        height: detailHeight,
        label: detailText,
        attrs: {
          body: {
            fill: 'rgba(255, 255, 255, 0.95)',
            stroke: '#409eff',
            strokeWidth: 2,
            rx: 8,
            ry: 8
          },
          label: {
            fontSize: 12,
            fill: '#333',
            textAnchor: 'start',
            textVerticalAnchor: 'top',
            refX: 15,
            refY: 15,
            textWrap: {
              width: detailWidth - 30,
              height: detailHeight - 30
            }
          }
        },
        data: {
          isNodeDetail: true,
          detailFor: node.id,
          isDetailBox: true // 标记为详情框，用于鼠标事件处理
        },
        zIndex: 100
      })
      this.nodeDetailNodes.push(detailNode)
    },
    
    // 双击拖拽相关方法
    togglePanning(event) {
      // 只在空白区域双击时切换拖拽状态
      if (event.target.closest('.x6-node') || event.target.closest('.x6-edge')) {
        return
      }
      
      this.isPanningEnabled = !this.isPanningEnabled
      
      if (this.isPanningEnabled) {
        // 启用拖拽
        this.graph.enablePanning()
        document.body.style.cursor = 'grab'
        this.$message.success('拖拽模式已启用，可以拖动画布')
      } else {
        // 禁用拖拽
        this.graph.disablePanning()
        document.body.style.cursor = 'default'
        this.$message.info('拖拽模式已禁用')
      }
    },
    
    // 在画布上显示关键词详细信息
    showKeywordDetailOnCanvas(node) {
      const relationshipData = this.selectedRelationship
      if (!relationshipData) return
      
      const keyword = node.getLabel()
      
      // 找到相关的事件
      const relatedEvents = this.entityAnalysisData.events.filter(event => 
        event.participants?.includes(relationshipData.source) && 
        event.participants?.includes(relationshipData.target) &&
        (event.keywords?.includes(keyword) || event.description?.includes(keyword))
      )
      
      // 获取被点击节点的位置
      const clickedNodePos = node.getPosition()
      const clickedNodeSize = node.getSize()
      
      // 构建详情文本
      let detailText = `${keyword}`
      if (relationshipData.description) {
        detailText += `\n${relationshipData.description}`
      }
      if (relationshipData.citation) {
        detailText += `\n引文："${relationshipData.citation}"`
      }
      if (relatedEvents.length > 0) {
        detailText += `\n相关事件：`
        relatedEvents.slice(0, 2).forEach((event, index) => {
          detailText += `\n  ${index + 1}. ${event.description}`
          if (event.citation) {
            detailText += `\n     引文: "${event.citation}"`
          }
        })
      }
      if (relatedEvents.length === 0 && relationshipData.description) {
        detailText += `\n含义：${relationshipData.description}`
      }
      
      // 计算详情显示位置（距离节点80像素远，在下方）
      const detailWidth = 300
      const lineHeight = 16
      const textLines = detailText.split('\n')
      const detailHeight = textLines.length * lineHeight + 25
      
      // 获取画布实际尺寸 - 使用正确的容器
      const draftContainer = document.querySelector('.draft-container')
      const canvasWidth = draftContainer ? draftContainer.clientWidth : 1200
      const canvasHeight = window.innerHeight * 0.9
      
      // 优先显示在上方，避免遮挡关系详情框
      let detailStartX = clickedNodePos.x - (detailWidth - clickedNodeSize.width) / 2 // 水平居中对齐
      let detailStartY = clickedNodePos.y - detailHeight - 80
      
      // 确保不超出左右边界
      if (detailStartX < 20) {
        detailStartX = 20
      }
      if (detailStartX + detailWidth > canvasWidth - 20) {
        detailStartX = canvasWidth - detailWidth - 20
      }
      
      // 确保不超出上边界，如果超出则显示在下方
      if (detailStartY < 20) {
        detailStartY = clickedNodePos.y + clickedNodeSize.height + 80
      }
      
      // 创建单个详情文本节点
      const detailNode = this.graph.addNode({
        id: `keyword_detail_${Date.now()}`,
        x: detailStartX,
        y: detailStartY,
        width: detailWidth,
        height: detailHeight,
        label: detailText,
        attrs: {
          body: {
            fill: 'rgba(255, 248, 224, 0.95)',
            stroke: '#f57c00',
            strokeWidth: 2,
            rx: 8,
            ry: 8
          },
          label: {
            fontSize: 11,
            fill: '#333',
            textAnchor: 'start',
            textVerticalAnchor: 'top',
            refX: 12,
            refY: 12,
            textWrap: {
              width: detailWidth - 24,
              height: detailHeight - 24
            }
          }
        },
        data: {
          isNodeDetail: true,
          detailFor: node.id,
          isDetailBox: true // 标记为详情框，用于鼠标事件处理
        },
        zIndex: 100
      })
      this.nodeDetailNodes.push(detailNode)
    },
    
    // 在画布上显示描述详细信息
    showDescriptionDetailOnCanvas(node) {
      const relationshipData = this.selectedRelationship
      if (!relationshipData) return
      
      // 找到相关的事件
      const relatedEvents = this.entityAnalysisData.events.filter(event => 
        event.participants?.includes(relationshipData.source) && 
        event.participants?.includes(relationshipData.target)
      )
      
      // 获取被点击节点的位置
      const clickedNodePos = node.getPosition()
      const clickedNodeSize = node.getSize()
      
      // 构建详情文本
      let detailText = `关系描述：${relationshipData.description}`
      detailText += `\n关系类型：${relationshipData.type === 'direct' ? '直接关系' : '间接关系'}`
      
      if (relationshipData.citation) {
        detailText += `\n原文引用："${relationshipData.citation}"`
      }
      
      if (relationshipData.keywords && relationshipData.keywords.length > 0) {
        detailText += `\n关键词：${relationshipData.keywords.join(', ')}`
      }
      
      if (relatedEvents.length > 0) {
        detailText += `\n相关事件：`
        relatedEvents.slice(0, 2).forEach((event, index) => {
          detailText += `\n  ${index + 1}. ${event.description}`
          if (event.citation) {
            detailText += `\n     引文: "${event.citation}"`
          }
          if (event.keywords && event.keywords.length > 0) {
            detailText += `\n     关键词: ${event.keywords.join(', ')}`
          }
        })
      }
      
      // 计算详情显示位置（距离节点100像素远，在上方）
      const detailWidth = 350
      const lineHeight = 16
      const textLines = detailText.split('\n')
      const detailHeight = textLines.length * lineHeight + 30
      
      // 获取画布实际尺寸 - 使用正确的容器
      const draftContainer = document.querySelector('.draft-container')
      const canvasWidth = draftContainer ? draftContainer.clientWidth : 1200
      const canvasHeight = window.innerHeight * 0.9
      
      // 优先显示在上方，避免遮挡关系详情框
      let detailStartX = clickedNodePos.x - (detailWidth - clickedNodeSize.width) / 2 // 水平居中对齐
      let detailStartY = clickedNodePos.y - detailHeight - 80
      
      // 确保不超出左右边界
      if (detailStartX < 20) {
        detailStartX = 20
      }
      if (detailStartX + detailWidth > canvasWidth - 20) {
        detailStartX = canvasWidth - detailWidth - 20
      }
      
      // 确保不超出上边界，如果超出则显示在下方
      if (detailStartY < 20) {
        detailStartY = clickedNodePos.y + clickedNodeSize.height + 80
      }
      
      // 创建单个详情文本节点
      const detailNode = this.graph.addNode({
        id: `desc_detail_${Date.now()}`,
        x: detailStartX,
        y: detailStartY,
        width: detailWidth,
        height: detailHeight,
        label: detailText,
        attrs: {
          body: {
            fill: 'rgba(245, 245, 245, 0.95)',
            stroke: '#999',
            strokeWidth: 2,
            rx: 8,
            ry: 8
          },
          label: {
            fontSize: 11,
            fill: '#333',
            textAnchor: 'start',
            textVerticalAnchor: 'top',
            refX: 15,
            refY: 15,
            textWrap: {
              width: detailWidth - 30,
              height: detailHeight - 30
            }
          }
        },
        data: {
          isNodeDetail: true,
          detailFor: node.id,
          isDetailBox: true // 标记为详情框，用于鼠标事件处理
        },
        zIndex: 100
      })
      this.nodeDetailNodes.push(detailNode)
    },
    
    // 在画布上显示元素描述详细信息
    showElementDescriptionOnCanvas(elementNode) {
      // 清除之前的详情显示
      this.clearNodeDetails()
      
      const elementData = elementNode.getData()?.elementData
      
      if (!elementData || !elementData.description) {
        return
      }
      
      
      // 构建描述文本
      const descriptionText = elementData.description
      
      
      // 计算详情显示位置
      const lineHeight = 15 // 适当调整行高，确保文本可读
      const padding = 12 // 缩小内边距
      
      // 动态计算文本宽度 - 更精确的方法
      const calculateTextWidth = (text) => {
        // 创建一个临时的span元素来测量实际文本宽度
        const span = document.createElement('span')
        span.style.fontSize = '13px'
        span.style.fontFamily = 'Microsoft YaHei, sans-serif'
        span.style.visibility = 'hidden'
        span.style.position = 'absolute'
        span.style.whiteSpace = 'nowrap'
        span.textContent = text
        
        document.body.appendChild(span)
        const width = span.getBoundingClientRect().width
        document.body.removeChild(span)
        
        return width
      }
      
      // 按句号、分号等分割文本，计算每行的宽度
      const textLines = descriptionText.split(/[；;。．\n]/).filter(line => line.trim())
      let maxLineWidth = 0
      
      textLines.forEach(line => {
        const trimmedLine = line.trim()
        if (trimmedLine) {
          const lineWidth = calculateTextWidth(trimmedLine)
          // 如果单行太长，考虑合理的换行宽度
          const reasonableWidth = Math.min(lineWidth, 600) // 单行最大600px
          if (reasonableWidth > maxLineWidth) {
            maxLineWidth = reasonableWidth
          }
        }
      })
      
      // 如果没有明显的分割点，计算整体文本的合理宽度
      if (maxLineWidth === 0) {
        const totalWidth = calculateTextWidth(descriptionText)
        // 根据文本长度智能确定宽度
        if (totalWidth <= 400) {
          maxLineWidth = totalWidth
        } else if (totalWidth <= 800) {
          maxLineWidth = Math.min(totalWidth * 0.7, 500) // 适当压缩
        } else {
          maxLineWidth = 400 // 长文本使用固定宽度，依靠换行
        }
      }
      
      // 设置最小和最大宽度
      const minWidth = 250
      const maxWidth = 700
      const calculatedWidth = maxLineWidth + padding * 2
      const detailWidth = Math.min(Math.max(calculatedWidth, minWidth), maxWidth)
      
      // 重新计算文本行数（基于实际宽度）
      const charactersPerLine = Math.floor((detailWidth - padding * 2) / 8) // 假设每个字符约8px宽
      const estimatedLines = Math.ceil(descriptionText.length / charactersPerLine)
      
      // 考虑手动换行（分号、句号等）和实际文本行数
      const manualBreaks = (descriptionText.match(/[；;。．\n]/g) || []).length
      const actualTextLines = textLines.length
      const totalLines = Math.max(estimatedLines, manualBreaks + 1, actualTextLines, 2) // 至少2行高度
      
      // 设置最小和最大高度
      const minHeight = 45 // 适当调整最小高度，确保内容可见
      const maxHeight = 250 // 进一步缩小最大高度
      const calculatedHeight = totalLines * lineHeight + padding * 2
      const detailHeight = Math.min(Math.max(calculatedHeight, minHeight), maxHeight)
      
      
      // 获取画布实际尺寸
      const draftContainer = document.querySelector('.draft-container')
      const canvasWidth = draftContainer ? draftContainer.clientWidth : 1200
      const canvasHeight = window.innerHeight * 0.9
      
      // 获取点击节点的位置和大小
      const clickedNodePos = elementNode.getPosition()
      const clickedNodeSize = elementNode.getSize()
      
      // 计算详情框位置（显示在元素右侧）
      let detailStartX = clickedNodePos.x + clickedNodeSize.width + 20
      let detailStartY = clickedNodePos.y
      
      // 边界检测 - 如果右侧空间不够，显示在左侧
      if (detailStartX + detailWidth > canvasWidth - 20) {
        detailStartX = clickedNodePos.x - detailWidth - 20
      }
      
      // 垂直边界检测
      if (detailStartY + detailHeight > canvasHeight - 20) {
        detailStartY = canvasHeight - detailHeight - 20
      }
      if (detailStartY < 20) {
        detailStartY = 20
      }
      
      // 创建详情显示节点
      const detailNode = this.graph.addNode({
        id: `element_detail_${elementData.id}_${Date.now()}`,
        x: detailStartX,
        y: detailStartY,
        width: detailWidth,
        height: detailHeight,
        label: descriptionText,
        attrs: {
          body: {
            fill: '#999999', // 灰色背景，不透明
            stroke: 'none', // 无边框
            strokeWidth: 0,
            rx: 8,
            ry: 8
          },
          label: {
            fontSize: 13,
            fill: '#ffffff', // 白色文字
            textAnchor: 'start',
            textVerticalAnchor: 'top',
            refX: padding,
            refY: padding,
            textWrap: {
              width: detailWidth - padding * 2,
              height: detailHeight - padding * 2,
              ellipsis: false, // 不使用省略号
              breakWord: true // 允许单词内换行
            }
          }
        },
        data: {
          isElementDetail: true,
          elementId: elementData.id,
          isDetailBox: true // 标记为详情框，用于鼠标事件处理
        },
        zIndex: 100
      })
      
      this.nodeDetailNodes.push(detailNode)
    },
    
    // 生成元素描述的HTML内容
    generateElementDescriptionHTML(elementData) {
      const descriptionParts = elementData.description.split(/[；;]/).filter(part => part.trim())
      
      let html = `
        <div style="padding: 12px; font-family: 'Microsoft YaHei', sans-serif; color: #333; line-height: 1.6;">
          <div style="font-weight: bold; color: #409eff; margin-bottom: 8px; font-size: 14px;">
            ${elementData.text}
          </div>
      `
      
      descriptionParts.forEach(part => {
        html += `<div style="margin-bottom: 4px; font-size: 13px; color: #666;">${part.trim()}</div>`
      })
      
      html += '</div>'
      return html
    },
    
    // 显示实体悬浮提示框
    showEntityHoverTooltip(node, e) {
      const entityId = node.getData()?.entityId
      if (!entityId || !this.entityAnalysisData) return
      
      const entity = this.entityAnalysisData.entities.find(e => e.id === entityId)
      if (!entity) return
      
      // 判断是否为中心实体（当前选中的实体）
      const isCenterEntity = entityId === this.selectedEntityId
      
      let content = ''
      if (isCenterEntity) {
        // 中心实体显示详细信息
        content = `实体：${entity.name}`
        if (entity.attribute) {
          content += `\n属性：${entity.attribute}`
        }
        if (entity.event) {
          content += `\n事件：${entity.event}`
        }
        
        // 显示相关关系
        const relatedRelationships = this.entityAnalysisData.relationships.filter(rel => 
          rel.source === entityId || rel.target === entityId
        )
        if (relatedRelationships.length > 0) {
          content += `\n相关关系：`
          relatedRelationships.slice(0, 3).forEach((rel, index) => {
            const otherEntityId = rel.source === entityId ? rel.target : rel.source
            const otherEntity = this.entityAnalysisData.entities.find(e => e.id === otherEntityId)
            const otherEntityName = otherEntity ? otherEntity.name : otherEntityId
            const keywords = rel.keywords ? rel.keywords.join(', ') : '无关键词'
            content += `\n  ${index + 1}. 与"${otherEntityName}": ${keywords}`
          })
        }
        
        // 显示参与的事件
        const relatedEvents = this.entityAnalysisData.events.filter(event => 
          event.participants?.includes(entityId)
        )
        if (relatedEvents.length > 0) {
          content += `\n参与事件：`
          relatedEvents.slice(0, 2).forEach((event, index) => {
            content += `\n  ${index + 1}. ${event.description}`
          })
        }
      } else {
        // 相连实体显示基本信息和与中心实体的关系
        content = `实体：${entity.name}`
        if (entity.attribute) {
          content += `\n属性：${entity.attribute}`
        }
        
        // 查找与中心实体的关系
        if (this.selectedEntityId) {
          const relationWithCenter = this.entityAnalysisData.relationships.find(rel => 
            (rel.source === entityId && rel.target === this.selectedEntityId) ||
            (rel.source === this.selectedEntityId && rel.target === entityId)
          )
          
          if (relationWithCenter) {
            const centerEntity = this.entityAnalysisData.entities.find(e => e.id === this.selectedEntityId)
            const centerEntityName = centerEntity ? centerEntity.name : this.selectedEntityId
            const keywords = relationWithCenter.keywords ? relationWithCenter.keywords.join(', ') : '无关键词'
            content += `\n与"${centerEntityName}"的关系：${keywords}`
            
            if (relationWithCenter.description) {
              content += `\n关系描述：${relationWithCenter.description}`
            }
          }
        }
      }
      
      // 获取鼠标位置
      const containerRect = document.getElementById('graph-container').getBoundingClientRect()
      const x = e.clientX - containerRect.left + 10
      const y = e.clientY - containerRect.top - 10
      
      this.entityHoverTooltip = {
        visible: true,
        content: content,
        x: x,
        y: y
      }
    },
    
    // 隐藏实体悬浮提示框
    hideEntityHoverTooltip() {
      this.entityHoverTooltip.visible = false
    },
    
    // 显示关系悬浮提示框
    showRelationshipHoverTooltip(edge, e) {
      const relationshipData = edge.getData()?.relationshipData
      if (!relationshipData) return
      
      // 获取源实体和目标实体信息
      const sourceEntity = this.entityAnalysisData.entities.find(e => e.id === relationshipData.source)
      const targetEntity = this.entityAnalysisData.entities.find(e => e.id === relationshipData.target)
      
      if (!sourceEntity || !targetEntity) return
      
      let content = `关系：${sourceEntity.name} → ${targetEntity.name}`
      
      // 显示关键词
      if (relationshipData.keywords && relationshipData.keywords.length > 0) {
        content += `\n关键词：${relationshipData.keywords.join(', ')}`
      }
      
      // 显示描述
      if (relationshipData.description) {
        content += `\n描述：${relationshipData.description}`
      }
      
      // 显示引用
      if (relationshipData.citation) {
        content += `\n引文："${relationshipData.citation}"`
      }
      
      // 显示相关事件
      const relatedEvents = this.entityAnalysisData.events.filter(event => 
        event.participants?.includes(relationshipData.source) && 
        event.participants?.includes(relationshipData.target)
      )
      
      if (relatedEvents.length > 0) {
        content += `\n相关事件：`
        relatedEvents.slice(0, 2).forEach((event, index) => {
          content += `\n  ${index + 1}. ${event.description}`
          if (event.citation) {
            content += `\n     引文: "${event.citation}"`
          }
        })
      }
      
      // 获取鼠标位置
      const containerRect = document.getElementById('graph-container').getBoundingClientRect()
      const x = e.clientX - containerRect.left + 10
      const y = e.clientY - containerRect.top - 10
      
      this.relationshipHoverTooltip = {
        visible: true,
        content: content,
        x: x,
        y: y
      }
    },
    
    // 隐藏关系悬浮提示框
    hideRelationshipHoverTooltip() {
      this.relationshipHoverTooltip.visible = false
    }
  },
  mounted () {
    const copyBtn = new ClipboardJS('#copyBtn')

    copyBtn.on('success', (e) => {
      this.$message.success('站外分享链接复制成功, 您可以发送给你的好友')
    })
    const w = document.querySelector('.draft-container').clientWidth
    const h = window.innerHeight * 0.9
    this.graph = new Graph({
      container: document.getElementById('graph-container'),
      grid: true,
      width: w,
      height: h,
      connecting: {
        snap: {
          radius: 50
        },
        enabled: true, // 开启连线交互
        allowMulti: true, // 是否允许在相同的起始节点和终止之间创建多条边
        allowNode: false, // 是否允许边链接到节点（非节点上的链接桩）
        allowBlank: false, // 是否允许连接到空白点
        allowLoop: true, // 是否允许创建循环连线，即边的起始节点和终止节点为同一节点，
        allowEdge: false, // 是否允许边链接到另一个边
        highlight: true, // 拖动边时，是否高亮显示所有可用的连接桩或节点
        connectionPoint: 'anchor', // 指定连接点
        anchor: 'midSide', // 指定被连接的节点的锚点
        createEdge () {
          return this.createEdge({
            attrs: {
              line: {
                stroke: '#8f8f8f',
                strokeWidth: 2
              }
            },
            zIndex: 100, // 提高默认层级，确保线条不被框遮挡
            router: {
              name: 'orth' // 使用折线路由
            },
            connector: {
              name: 'rounded' // 使用圆角连接器，使折线更美观
            }
          })
        }
      },
      background: {
        color: '#F2F7FA'
      },
      highlighting: {
        magnetAvailable: {
          name: 'stroke',
          args: {
            padding: 4,
            attrs: {
              strokeWidth: 20,
              stroke: 'rgba(223,234,255)'
            }
          }
        },
        // 禁用默认的节点高亮
        default: {
          name: 'stroke',
          args: {
            attrs: {
              stroke: 'transparent',
              strokeWidth: 0
            }
          }
        }
      },
      interacting: {
        // node 是否可以拖动
        nodeMovable: ({ cell }) => {
          if (cell.getData()?.selectable === false) {
            return false
          }
          // 关系详情节点和节点详情不可移动
          if (cell.getData()?.isRelationshipDetail || cell.getData()?.isNodeDetail) {
            return false
          }
          // 分类分析的元素节点现在可以单独移动
          return true
        }
      },
      // 开启画布缩放
      mousewheel: {
        enabled: true,
        modifiers: [], // 移除修饰键要求，直接使用滚轮控制缩放
        minScale: 0.5,
        maxScale: 2
      },
      // 启用拖拽平移，但通过自定义逻辑控制
      panning: {
        enabled: true
      },
      moving: {
        enabled: false
      },
      resizing: {
        enabled: true
      },
      rotating: true
    })
    window.graph = this.graph
    window.draftComponent = this
    const keyboard = new Keyboard({
      enabled: true,
      global: true
    })
    // 创建 selection 实例
    const selectionInstance = new Selection({
      enabled: true, // 是否开启
      multiple: true, // 是否启动多选
      rubberband: true, // 是否启用框选节点功能
      movable: true, // 允许拖动选框时框选的节点一起移动
      showNodeSelectionBox: true,
      showEdgeSelectionBox: false,
      pointerEvents: 'none',
      // 自定义选择框显示逻辑
      filter: (node) => {
        // 对于隐藏的节点，不显示选择框
        if (node.visible === false) {
          return false
        }
        // 对于不可见的组合节点，不显示选择框
        if (node.getData()?.invisible) {
          return false
        }
        // 对于明确标记为不可选择的节点，不显示选择框
        if (node.getData()?.selectable === false) {
          return false
        }
        // 如果节点属于某个组合，且父组合节点被选中，则不显示子节点的选择框
        if (node.getData()?.parentGroup) {
          const parentGroupId = node.getData().parentGroup
          const selectedCells = selectionInstance.getSelectedCells()
          const parentGroupSelected = selectedCells.some(cell => 
            cell.id === parentGroupId && cell.getData()?.isGroup
          )
          if (parentGroupSelected) {
            return false
          }
        }
        return true
      }
    })
    this.selection = selectionInstance
    const clipboard = new Clipboard({
      enabled: true
    })
    const snapline = new Snapline({
      enabled: true,
      clean: false
    })
    const transform = new Transform({
      resizing: {
        enabled: (node) => {
          // 禁用关系详情节点和节点详情的调整大小功能
          if (node.getData()?.isRelationshipDetail || node.getData()?.isNodeDetail) {
            return false
          }
          // 对于明确标记为不可选择的节点，禁用调整大小
          if (node.getData()?.selectable === false) {
            return false
          }
          return true
        },
        orthogonal: true
      }
    })
    this.history = new History({
      enabled: true,
      beforeAddCommand (event, args) {
        if (args.key === 'tools') {
          return false
        }
      }
    })
    this.exportInstance = new Export()
    this.graph.use(keyboard)
    this.graph.use(this.selection)
    this.graph.use(clipboard)
    this.graph.use(snapline)
    this.graph.use(transform)
    this.graph.use(this.exportInstance)
    this.graph.use(this.history)
    // 过滤选中
    this.selection.setSelectionFilter((cell) => {
      // 对于隐藏的节点，不可选择
      if (cell.isNode() && cell.visible === false) {
        return false
      }
      // 不可选择的节点
      if (cell.getData()?.selectable === false) {
        return false
      }
      // 关系详情节点和节点详情不可选择
      if (cell.getData()?.isRelationshipDetail || cell.getData()?.isNodeDetail) {
        return false
      }
      // 如果节点属于某个组合，且父组合节点也被选中，则过滤掉子节点（只选中组合节点）
      if (cell.getData()?.parentGroup) {
        const parentGroupId = cell.getData().parentGroup
        const selectedCells = this.selection.getSelectedCells()
        const parentGroupSelected = selectedCells.some(selectedCell => 
          selectedCell.id === parentGroupId && selectedCell.getData()?.isGroup
        )
        if (parentGroupSelected) {
          return false
        }
      }
      // 分类分析的元素节点现在可以选择和拖拽
      return true
    })
    this.graph.on('history:change', () => {
      this.canRedo = this.history?.canRedo()
      this.canUndo = this.history?.canUndo()
    })
    this.graph.on('edge:click', (e) => {
      // 处理关系线条点击 - 已移除弹窗显示功能
      if (e.edge.getData()?.isRelationship) {
        // 高亮连接线两端的节点
        this.highlightRelationshipNodes(e.edge)
        return
      }
      
      this.edgeVisible = true
      this.currentEdge = e.edge
    })
    this.graph.on('blank:click', ({ e }) => {
      this.$emit('move')
      this.menuShow = false
      
      // 点击空白区域时只清除详情显示，保持实体关系和颜色状态
      if (this.entityAnalysisData) {
        this.clearRelationshipDetails()
        this.clearNodeDetails()
        // 重置关系线条高亮和节点高亮
        this.resetRelationshipHighlight()
        // 不重置选中状态和关系显示
      }
    })
    // 菜单
    this.graph.on('node:contextmenu', ({ e, node }) => {
      // 如果节点明确标记为不可选择，则不显示右键菜单
      if (node.getData()?.selectable === false) {
        return
      }
      const { clientX, clientY } = e
      this.menuShow = true
      // 总宽度 - 画布宽度 / 2
      const w = window.innerWidth * 0.15
      this.menu = {
        x: clientX - w,
        y: clientY - 60
      }
      this.currentNode = node
    })
    this.graph.on('node:mouseenter', ({ node, e }) => {
      if (node?.data?.isMore && !this.tooltipMore) {
        const x = e.offsetX
        const y = e.offsetY
        this.tooltipObj = {
          x,
          y
        }
        this.tooltipMore = true
        this.tooltipText = node.data.originLabel
      }
      
      // 处理实体关系分析中的实体节点悬浮
      if (this.entityAnalysisData && node.getData()?.entityId) {
        this.showEntityHoverTooltip(node, e)
        return
      }
      
      // 处理关系详情节点悬浮
      if (node.getData()?.isRelationshipDetail) {
        this.handleDetailNodeHover(node)
        return
      }
      
      // 处理详情框悬浮（保持详情框显示）
      if (node.getData()?.isDetailBox) {
        // 鼠标进入详情框时，取消清除操作
        return
      }
      
      // 显示端口的条件：不可选择的节点 或 分类分析的元素节点
      if (!node.getData()?.selectable || (node.getData()?.isElement && node.getData()?.elementData)) {
        this.showPorts(true, node)
      }
    })
    this.graph.on('node:mouseleave', ({ node }) => {
      this.showPorts(false, node)
      if (this.tooltipMore) {
        this.tooltipMore = false
      }
      
      // 处理实体关系分析中的实体节点悬浮离开
      if (this.entityAnalysisData && node.getData()?.entityId) {
        this.hideEntityHoverTooltip()
        return
      }
      
      // 处理关系详情节点悬浮离开
      if (node.getData()?.isRelationshipDetail) {
        this.handleDetailNodeLeave(node)
        return
      }
      
      // 处理详情框悬浮离开
      if (node.getData()?.isDetailBox) {
        this.handleDetailBoxLeave(node)
        return
      }
    })
    this.graph.on('node:mouseup', ({ node }) => {
      this.hideSnapline()
    })
    this.graph.on('edge:mouseenter', ({ edge, e }) => {
      // 处理实体关系分析中的关系线条悬浮
      if (this.entityAnalysisData && edge.getData()?.isRelationship) {
        this.showRelationshipHoverTooltip(edge, e)
        return
      }
      
      edge.addTools([
        {
          name: 'button-remove'
        }
      ])
    })
    this.graph.on('node:resized', ({ node }) => {
      this.updatePort(node)
    })
    this.graph.on('node:click', ({ node, e }) => {
      this.$emit('move')
      
      // 如果按住Ctrl键，允许多选，不做特殊处理
      if (e.ctrlKey || e.metaKey) {
        return
      }
      
      // 分类分析元素点击处理
      if (node.getData()?.isElement && node.getData()?.elementData) {
        // 强制保持子元素的高层级，防止被分类框遮挡
        node.setZIndex(10)
        
        // 显示元素描述框
        this.showElementDescriptionOnCanvas(node)
        
        return
      }
      
      // 处理实体节点点击
      if (node.getData()?.isEntity) {
        const entityId = node.getData().entityId
        if (entityId) {
          // 如果点击的是当前选中的实体，则清除关系显示并重置颜色
          if (this.selectedEntityId === entityId) {
            this.clearRelationshipEdges()
          } else {
            // 显示该实体的关系，移动到中心并更新颜色
            this.showEntityRelationships(entityId)
          }
        }
        return
      }
      
      // 关系详情节点现在使用悬浮交互，不需要点击处理
      if (node.getData()?.isRelationshipDetail) {
        return
      }
      
      // 检查是否有子节点，如果有则让nodeEvent.js处理收起/展开逻辑
      const nodeList = this.graph.getNodes()
      let hasChildNodes = false
      
      // 检查普通节点是否有子节点
      const childList = nodeList.filter((item) => {
        if (item?.data?.id) {
          return item?.data?.id?.includes(node.id) && item?.data?.id !== node.id
        } else {
          return item?.id?.includes(node.id) && item?.id !== node.id
        }
      })
      
      if (childList.length > 0) {
        hasChildNodes = true
      }
      
      // 检查组合节点中是否包含有子节点的父节点
      if (node.getData()?.isGroup && node.getData()?.groupedNodes) {
        const groupedNodeIds = node.getData().groupedNodes || []
        
        for (const nodeId of groupedNodeIds) {
          const candidateNode = this.graph.getCellById(nodeId)
          if (candidateNode) {
            const candidateChildList = nodeList.filter((item) => {
              if (item?.data?.id) {
                return item?.data?.id?.includes(candidateNode.id) && item?.data?.id !== candidateNode.id
              } else {
                return item?.id?.includes(candidateNode.id) && item?.id !== candidateNode.id
              }
            })
            
            if (candidateChildList.length > 0) {
              hasChildNodes = true
              break
            }
          }
        }
      }
      
      // 如果有子节点，则不处理组合选择逻辑，让nodeEvent.js处理
      if (hasChildNodes) {
        return
      }
      
      // 如果点击的节点属于某个组合，则选择整个组合
      if (node.getData()?.parentGroup) {
        const groupId = node.getData().parentGroup
        const groupNode = this.graph.getCellById(groupId)
        if (groupNode) {
          this.selection.reset()
          this.selection.select(groupNode)
        }
      }
    })
    this.graph.on('edge:mouseleave', ({ edge }) => {
      // 处理实体关系分析中的关系线条悬浮离开
      if (this.entityAnalysisData && edge.getData()?.isRelationship) {
        this.hideRelationshipHoverTooltip()
        return
      }
      
      edge.removeTools()
    })
    // this.graph.on('node:dblclick', ({ node, e }) => {
      // node.addTools({
      //   name: 'node-editor',
      //   args: {
      //     event: e,
      //   },
      // })
    // })
    this.graph.on('node:changed', ({ node }) => {
      const targetEdge = this.graph.getIncomingEdges(node.id) || []
      const sourceEdge = this.graph.getOutgoingEdges(node.id) || []
      const edgeList = [...targetEdge, ...sourceEdge]
      for (const item of edgeList) {
        const connector = item.getConnector()
        const router = item.getRouter()
        
        // 直线和折线不需要手动处理顶点
        if (connector === 'normal' || (router && router.name === 'orth')) {
          continue
        }
        // 只有曲线需要重新计算顶点
        if (connector === 'smooth' || (connector && connector.name === 'smooth')) {
          const point = this.newVertices(
            item.getTargetNode(),
            item.getSourceNode()
          )
          item.vertices = point
        }
      }
    })
    this.graph.on('node:selected', ({ e }) => {
      this.showPorts(false)
      this.updateGroupButtons()
    })
    // 监听选择变化
    this.graph.on('selection:changed', ({ added, removed }) => {
      // 如果选中了组合节点，自动取消子节点的选中状态，避免显示黄色虚线框
      const selectedCells = this.selection.getSelectedCells()
      const selectedGroupNodes = selectedCells.filter(cell => 
        cell.isNode() && cell.getData()?.isGroup && cell.getData()?.groupedNodes
      )
      
      if (selectedGroupNodes.length > 0) {
        // 收集所有需要取消选中的子节点
        const childNodesToUnselect = []
        selectedGroupNodes.forEach(groupNode => {
          const groupedNodeIds = groupNode.getData().groupedNodes || []
          groupedNodeIds.forEach(nodeId => {
            const childNode = this.graph.getCellById(nodeId)
            if (childNode && this.selection.isSelected(childNode)) {
              childNodesToUnselect.push(childNode)
            }
          })
        })
        
        // 取消子节点的选中状态
        if (childNodesToUnselect.length > 0) {
          this.selection.unselect(childNodesToUnselect)
        }
      }
      
      // 如果框选时同时选中了组合节点和其子节点，只保留组合节点
      // 检查是否有子节点被选中，但其父组合节点也被选中
      const allSelectedNodes = selectedCells.filter(cell => cell.isNode())
      const childNodesToRemove = []
      
      allSelectedNodes.forEach(node => {
        if (node.getData()?.parentGroup) {
          const parentGroupId = node.getData().parentGroup
          const parentGroupSelected = selectedCells.some(cell => 
            cell.id === parentGroupId && cell.getData()?.isGroup
          )
          if (parentGroupSelected) {
            childNodesToRemove.push(node)
          }
        }
      })
      
      // 移除子节点的选中状态
      if (childNodesToRemove.length > 0) {
        this.selection.unselect(childNodesToRemove)
      }
      
      this.updateGroupButtons()
    })
    const event = new GraphOnEvent(this.graph, this.history)
    event.init(keyboard, this.selection, clipboard)

    const nodeEvent = new NodeEvent(this.graph)
    nodeEvent.init()
    this.graph.on('edge:connected', ({ edge, previous }) => {
      const point = this.newVertices(edge.getTargetNode(), edge.getSourceNode())
      edge.vertices = point
    })
    if (this.draftId) {
      this.getDetail()
    }
    // 添加双击拖拽事件监听器
    const graphContainer = document.getElementById('graph-container')
    
    // 初始时禁用拖拽
    this.graph.disablePanning()
    
    // 双击事件
    graphContainer.addEventListener('dblclick', (event) => {
      this.togglePanning(event)
    })

    this.group = new Group(this.graph)
  },
  beforeDestroy() {
    // 清理拖拽状态
    if (this.isPanningEnabled) {
      this.graph.disablePanning()
      document.body.style.cursor = 'default'
    }
  }
}
</script>

<style lang="scss">
.draft-container {
  width: 80vw;
  height: calc(100% - 80px);
  position: relative;
  background-color: #fff;
  margin: 20px auto !important;
  border: 1px solid #ddd;
  overflow: hidden;

  .more-tooltip {
    background: #303133;
    color: #fff;
    position: absolute;
    border-radius: 4px;
    padding: 10px;
    font-size: 12px;
    line-height: 1.2;
    min-width: 10px;
    max-width: 420px;
    word-wrap: break-word;
    z-index: 100;
  }

  // 实体悬浮提示框样式
  .entity-hover-tooltip {
    background: #ffffff;
    color: #333333;
    position: absolute;
    border-radius: 6px;
    padding: 12px;
    font-size: 13px;
    line-height: 1.4;
    min-width: 200px;
    max-width: 400px;
    word-wrap: break-word;
    z-index: 200;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: 1px solid #409eff;
    
    pre {
      margin: 0;
      padding: 0;
      font-family: inherit;
      white-space: pre-wrap;
      word-wrap: break-word;
      color: inherit;
      background: transparent;
    }
  }

  // 关系悬浮提示框样式
  .relationship-hover-tooltip {
    background: #ffffff;
    color: #333333;
    position: absolute;
    border-radius: 6px;
    padding: 12px;
    font-size: 13px;
    line-height: 1.4;
    min-width: 250px;
    max-width: 450px;
    word-wrap: break-word;
    z-index: 200;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: 1px solid #f57c00;
    
    pre {
      margin: 0;
      padding: 0;
      font-family: inherit;
      white-space: pre-wrap;
      word-wrap: break-word;
      color: inherit;
      background: transparent;
    }
  }

  .draft-con {
    width: 80vw;
  }
}

.x6-graph-svg {
  z-index: 2;
}

.x6-widget-selection {
  z-index: 1;
}

.x6-node-tool-editor {
  z-index: 3;
}


.friend-list {
  max-height: 350px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  /* 定义滚动条轨道的颜色 */
  &::-webkit-scrollbar-track {
    background: #409eff;
  }

  /* 定义滚动条滑块的样式 */
  &::-webkit-scrollbar-thumb {
    background: #409eff;
  }

  /* 鼠标悬停在滚动条上时滑块的样式 */
  &::-webkit-scrollbar-thumb:hover {
    background: #409eff;
  }

  .item-friend {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    border-bottom: 1px solid #ddd;
    padding: 10px 0;

    .el-checkbox__label {
      display: none;
    }

    .right {
      margin-left: 12px;
      display: flex;
      align-items: center;
    }

    .nick {
      color: #000;
      font-weight: 600;
      font-size: 16px;
      margin-left: 12px;
    }
  }

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

// .friend{
// width: 19px;
// height: 19px;
// position: relative;
// top: 1px;
// right: 8px;
// cursor: pointer;
// }

.x6-widget-transform {
  margin: -1px 0 0 -1px;
  padding: 0;
  border: 1px solid #239edd;
  border-radius: 6px;
  z-index: 10;
}

.x6-widget-transform>div {
  border: 1px solid #239edd;
}

.x6-widget-transform>div:hover {
  background-color: #3dafe4;
}

.x6-widget-transform-active-handle {
  background-color: #3dafe4;
}

.x6-widget-transform-resize {
  border-radius: 0;
}

.ant-card {
  box-shadow: 0 0 10px 1px #e9e9e9;
}

.ant-card-head-title {
  text-align: center;
}

.ant-row {
  margin: 16px 0;
  text-align: left;
}

.x6-widget-transform-resize {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.add-group-from {
  .item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
  }
}

.group-combo-form {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    
    label {
      min-width: 80px;
      font-weight: 500;
      color: #606266;
    }
  }
  
  .border-settings {
    margin-left: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    
    .item {
      margin-bottom: 15px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  .selected-nodes-info {
    margin-top: 20px;
    padding: 10px;
    background-color: #e1f3d8;
    border-radius: 4px;
    border-left: 4px solid #67c23a;
    
    p {
      margin: 0;
      color: #67c23a;
      font-weight: 500;
    }
  }
}

// 隐藏不可见组合节点的选择框
:deep(.x6-widget-selection-box) {
  &[data-invisible="true"] {
    display: none !important;
  }
}

// 禁用分类分析元素节点的选择和悬停效果
:deep(.x6-node[data-is-element="true"]) {
  .x6-node-body {
    &:hover {
      filter: none !important;
      opacity: 1 !important;
    }
  }
  
  // 禁用选择框
  &.x6-node-selected .x6-widget-selection-box {
    display: none !important;
  }
}

// 关系详情对话框样式
:deep(.relationship-detail-dialog) {
  .el-message-box__content {
    white-space: pre-line;
    text-align: left;
    max-height: 300px;
    overflow-y: auto;
  }
}

// 实体详情对话框样式
:deep(.entity-detail-dialog) {
  .el-message-box__content {
    white-space: pre-line;
    text-align: left;
    max-height: 400px;
    overflow-y: auto;
    font-family: 'Microsoft YaHei', sans-serif;
    line-height: 1.6;
  }
  
  .el-message-box {
    width: 600px;
    max-width: 90vw;
  }
}

// 关键词详情对话框样式
:deep(.keyword-detail-dialog) {
  .el-message-box__content {
    white-space: pre-line;
    text-align: left;
    max-height: 350px;
    overflow-y: auto;
    font-family: 'Microsoft YaHei', sans-serif;
    line-height: 1.5;
  }
  
  .el-message-box {
    width: 500px;
    max-width: 90vw;
  }
}

// 描述详情对话框样式
:deep(.description-detail-dialog) {
  .el-message-box__content {
    white-space: pre-line;
    text-align: left;
    max-height: 450px;
    overflow-y: auto;
    font-family: 'Microsoft YaHei', sans-serif;
    line-height: 1.6;
    padding: 20px;
  }
  
  .el-message-box {
    width: 650px;
    max-width: 95vw;
  }
}
</style>
